var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ErrorOutlineRounded, HistoryRounded, MoreVert } from '@mui/icons-material';
import { Box, Divider, Drawer, InputAdornment, Stack, Typography, useMediaQuery } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { nanoid } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { t } from 'i18next';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 } from 'uuid';
import { Config } from '../../../api/config';
import { ApllyUCN, deleteAllJobCardAttachmentsUrl, EstimateCheckExistUrl, GetActiveAccidentalConfigurationUrl, getAssociateCustomerUrl, getDownloadJobCardDocumentAttachmentUrl, getDownloadPreJobCardDocumentAttachmentUrl, getUCNByDocumentIdUrl, jobCardStatusProgressUrl, previousJobCardURLForRepeat, RemoveUcnUrl, RevisedEstimateCreateUrl, RevisedEstimateIsExistUrl, SendUcnCodeUrl, syncJobCardStatusURL, USER_PROFILE_DATA } from '../../../api/url';
import { AudioButtonIcon, DropDownIconNew } from '../../../assets/customIcons';
import { DeleteButtonNewIcon, GreenVerifiedTick, YellowWarningIcon } from '../../../assets/images';
import { ReactComponent as FileIcon } from '../../../assets/images/FileIcon.svg';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as Clapperboard } from '../../../assets/images/clapperboard.svg';
import { ReactComponent as VolumeMax } from '../../../assets/images/volume-max.svg';
import { Delete } from '../../../builderPackage/assets/svg';
import { getLoadingKey, getUpdateKey } from '../../../builderPackage/common/commonFunctions';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import useRbacController from '../../../builderPackage/rbac/useRbacController';
import { AudioPlayer, MuiButton, MuiPopup, MuiStack } from '../../../components';
import DrawerHeader from '../../../components/atoms/DrawerHeader';
import { MuiImagePopUp } from '../../../components/atoms/imageDialogBox';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import ViewAllImagePopUp from '../../../components/atoms/viewAllImagePopUp';
import AudioCapturePopUpComponent from '../../../components/molecules/audioCapturePopUpComoponent';
import VehicleInspectionStepper from "../../../components/molecules/jobCardProgressStepper";
import UnsavedChangesPopup from '../../../components/molecules/unsavedChangesPopup';
import AppointmentAssignReassignPopup from '../../../components/templates/AppointmentAssignReassignPopup';
import ImageCaptureAndFileupload from '../../../components/templates/captureImageAndFileUpload/imageCaptureAndFileupload';
import { accidentalDetailsFields, E_Channel_Name, EContactType, EListCardView, EMenuNames, EModuleSection, EParentModuleName, ESystemName, EUserRole, insuranceDetailsFields, isModuleConfig, LOCAL_STORAGE_KEYS, Module, PolicyNumberMaxLength, StatusEnum, steps } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { downloadAttachment, showError, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, resetState, setReducerState, setState } from '../../../redux/crudSlice';
import { socketIO } from '../../../socket';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getStatusColor } from '../../../theme/statusColors';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem, setLocalStorageItem } from '../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import { dateFormate, getCTAList, getMobileNumber, GoogleAnlyticsErrorLog, scrollToTop, sortImagesByTimeStamp } from '../../../utils/utils';
import ViewJobItems from '../../commonViews/customerComplaintView/componants/viewJobItems';
import { CustomerComplaintEditableDataGrid } from '../../commonViews/customerComplaintView/customerComplaintDatagrid';
import CustomerAndVehicleInfo from '../../commonViews/searchByType/customerAndVehicleInfo';
import { UCN_HELPER_TEXT_STATE } from '../../commonViews/serviceDetails/serviceDetailsComponent';
import JobCardReworkTab from '../../finalInspector/JobCardReworkTab';
import AssignFinalInspectorPopup from '../../jobCard/assignFinalInspectorPopup';
import { DelayedPopup } from '../../jobCard/jobcard.delayedPopup';
import NewCancelPopup from '../../jobCard/newJobcard/newJobCardCta/CancelCta';
import ReassignServiceAdvisor from '../../jobCard/newJobcard/newJobCardCta/ReassignServiceAdvisor';
import OptionAlert from '../../jobCard/repeat/optionsAlert';
import ServiceEstimateDrawer from '../../jobCard/serviceEstimateDrawer';
import { FIMenuFeatures, getFeaturesByStatusAndRbac, JcKey, JCMenuFeatures } from '../../jobCard/services/jcEntity';
import TaskSummary from '../../jobCard/taskSummary';
import { CombineJCPrint } from '../../prints/components/combineJCPrint';
import { TechnicianPrintPreview } from '../../prints/components/technicianPrintPreview';
import { APIKeys } from '../../spareIssue/services/entity';
import { PrintIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import JobCardMoreAction from '../components/jobCardMoreAction';
import JobcardLabourGrid from '../components/jobcardLabourGrid';
import JobcardPartGrid from '../components/jobcardPartGrid';
import OptionPopup from '../components/optionPopup';
import RecallLabourGrid from '../components/recallLabourGrid';
import RecallPartGrid from '../components/recallPartGrid';
import WarrantyDetails from '../components/warrantyDetails';
import { assignBayListAPICall, deleteAccidentalDetailsAttachment, floorSupervisorListAPICall, getAllJobCardDetailsAPICall, getCampaignList, getCoverageTypeList, getFinalInspectorListAPICall, getInsuranceProviderList, getLossTypeList, getNatureOfAccidentList, getServiceAdvisorAPICall, getTechnicianList, getWorkDistributionStatusList, updateJobCardDetailsApicall, validateDeletePartLabour } from '../services/apiCalls';
import { JobCardKeys } from '../services/entity';
import GetSocketUpdates from '../utils/getSocketUpdates';
import { useLabourElements } from '../utils/useLabourElements';
import { usePartElements } from '../utils/usePartElements ';
import { useFutureAdviseElements } from '../utils/useFutureAdviseElements';
import { recallLabourElements, recallPartElements, warrantyListElements } from './partAndlabourListData';
import FutureAdviseGrid from '../../futureAdvise/FutureAdviseGrid';
import AdvisorSuggestions from '../../commonViews/taskDetails/taskDetailsCommonComponent/AdvisorSuggestions';
import { checkModuleSectionUISettingMandatory } from '../utils/utils';
var JobCardDetailsM3 = function () {
    var _documentDetailsGetBy, _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, _CustomerVoice$data, _getLocalStorageItem, _documentDetailsGetBy8, _documentDetailsGetBy10, _documentDetailsGetBy13, _documentDetailsGetBy14, _documentDetailsGetBy27, _documentDetailsGetBy62, _documentDetailsGetBy63, _documentDetailsGetBy64, _documentDetailsGetBy65, _documentDetailsGetBy66, _documentDetailsGetBy67, _Object$keys, _accidentalDetailsCon2, _accidentalDetailsCon3, _accidentalDetailsCon4, _accidentalDetailsCon5, _accidentalDetailsCon6, _accidentalDetailsCon7, _accidentalDetailsCon8, _accidentalDetailsCon9, _accidentalDetailsCon10, _accidentalDetailsCon11, _accidentalDetailsCon12, _accidentalDetailsCon13, _accidentalDetailsCon14, _accidentalDetailsCon15, _accidentalDetailsCon16, _accidentalDetailsCon17, _Object$keys2, _accidentalDetailsCon21, _accidentalDetailsCon22, _accidentalDetailsCon23, _accidentalDetailsCon24, _accidentalDetailsCon25, _accidentalDetailsCon26, _accidentalDetailsCon27, _accidentalDetailsCon28, _accidentalDetailsCon29, _accidentalDetailsCon30, _accidentalDetailsCon31, _accidentalDetailsCon32, _accidentalDetailsCon33, _accidentalDetailsCon34, _accidentalDetailsCon35, _accidentalDetailsCon36, _accidentalDetailsCon37, _accidentalDetailsCon38, _documentDetailsGetBy69, _documentDetailsGetBy70, _documentDetailsGetBy71, _documentDetailsGetBy72, _documentDetailsGetBy73, _documentDetailsGetBy74, _documentDetailsGetBy82, _documentDetailsGetBy83, _documentDetailsGetBy84, _documentDetailsGetBy85, _documentDetailsGetBy86, _documentDetailsGetBy87, _documentDetailsGetBy88, _documentDetailsGetBy89, _documentDetailsGetBy90, _documentDetailsGetBy91, _documentDetailsGetBy92, _documentDetailsGetBy93, _documentDetailsGetBy94, _documentDetailsGetBy95, _documentDetailsGetBy96, _documentDetailsGetBy97, _documentDetailsGetBy98;
    var id = useParams().id;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var parentModulePath = (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector ? '/FinalInspection' : '/jobCard';
    var rbacControl = useRbacController(parentModulePath);
    var crud = useAppSelector(function (state) { return state.crud; });
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var documentDetailsGetById = crud.documentDetailsGetById, RevisedEstimateIsExist = crud.RevisedEstimateIsExist;
    var isDocDataUpdated = useSelector(function (state) { return state.common; }).isDocDataUpdated;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var _a = useState(false), openUpload = _a[0], setOpenUpload = _a[1];
    var isDisabled = [StatusEnum.Delivered, StatusEnum.Cancelled, StatusEnum.ReadyForInvoice, StatusEnum.Awaiting, StatusEnum.Invoiced, StatusEnum.FinalInspection].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) || "") || (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector && (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.Key) === StatusEnum.Rework || !(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy3 = documentDetailsGetById.data) !== null && _documentDetailsGetBy3 !== void 0 && _documentDetailsGetBy3.SourceDocumentNo);
    var isDisabledPrint = [StatusEnum.Cancelled, StatusEnum.Awaiting].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.Key) || "");
    var RepeatAlertDisabledForJC = [StatusEnum.ReadyForInvoice, StatusEnum.Invoiced, StatusEnum.Delivered, StatusEnum.Cancelled, StatusEnum.Awaiting].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.Key) || "");
    var _b = useState(false), openStatusProgress = _b[0], setOpenStatusProgress = _b[1];
    var trackButtonClick = useAnalyticsEventTracker("JobcardDetails");
    var _c = React.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = useState([]), progessSteps = _d[0], setProgressSteps = _d[1];
    var _e = useState(false), openPopup = _e[0], setOpenPopup = _e[1];
    var CustomerVoice = useAppSelector(function (state) { return state.crud; }).CustomerVoice;
    var CustomerVoiceData = CustomerVoice === null || CustomerVoice === void 0 || (_CustomerVoice$data = CustomerVoice.data) === null || _CustomerVoice$data === void 0 ? void 0 : _CustomerVoice$data.CustomerVoice[0];
    var _f = useState(), menus = _f[0], setMenus = _f[1];
    var serviceTypesData = getLocalStorageItem(LOCAL_STORAGE_KEYS.SERVICE_TYPES);
    var _g = React.useState(null), anchorElDelayedPopup = _g[0], setAnchorElDelayedPopup = _g[1];
    var statusList = getLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST);
    var _h = useState(), riderDetails = _h[0], setRiderDetails = _h[1];
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var _j = useState(null), previousJobcard = _j[0], setPreviousJobcard = _j[1];
    var _k = useState(false), isAssignFIModalOpen = _k[0], setIsAssignFIModalOpen = _k[1];
    var _l = useState(false), openTaskSummery = _l[0], setOpenTaskSummery = _l[1];
    var _m = useState(false), openServiceTypeModal = _m[0], setOpenServiceTypeModal = _m[1];
    var _o = useState(false), openServiceEstimate = _o[0], setOpenServiceEstimate = _o[1];
    var _p = useState(''), assignValue = _p[0], setAssignValue = _p[1];
    var _q = useState(false), isAssignModalOpen = _q[0], setIsAssignModalOpen = _q[1];
    var _r = useState(false), isUnsavedDataModalOpen = _r[0], setIsUnsavedDataModalOpen = _r[1];
    var _s = useState(false), isdataAlter = _s[0], setIsdataAlter = _s[1];
    var open = Boolean(anchorEl);
    var _t = useState(false), buttonName = _t[0], setButtonName = _t[1];
    var _u = useState(true), isShowSkeleton = _u[0], setShowSkeleton = _u[1];
    var _v = useState(''), revisedEstimateId = _v[0], setRevisedEstimateId = _v[1];
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var _w = useState(null), accidentalDetailsConfig = _w[0], setAccidentalDetailsConfig = _w[1];
    var _x = useState(false), isCancelModalOpen = _x[0], setIsCancelModalOpen = _x[1];
    var _y = useState([]), list = _y[0], setList = _y[1];
    var _z = useState(false), clearPopUpImages = _z[0], setClearPopUpImages = _z[1];
    var _0 = useState([]), accidentalDetailsPhotographList = _0[0], setAccidentalDetialsPhotographList = _0[1];
    var _1 = useState([]), accidentalDetailsAudioList = _1[0], setAccidentalDetialsAudioList = _1[1];
    var getStatus = function (name) {
        var _crud$JobCardKeys$Lab;
        return (_crud$JobCardKeys$Lab = crud[JobCardKeys.LabourStatusList]) === null || _crud$JobCardKeys$Lab === void 0 || (_crud$JobCardKeys$Lab = _crud$JobCardKeys$Lab.data) === null || _crud$JobCardKeys$Lab === void 0 ? void 0 : _crud$JobCardKeys$Lab.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === name; });
    };
    var _2 = useState([]), customerComplaintImagesList = _2[0], setCustomerComplaintImagesList = _2[1];
    var _3 = useState([]), customerComplaintAudiosList = _3[0], setCustomerComplaintAudiosList = _3[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var technicianList = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD)) !== null && _getLocalStorageItem !== void 0 ? _getLocalStorageItem : [];
    var _4 = useState(false), audioCaptureClick = _4[0], setAudioCaptureClick = _4[1];
    var _5 = useState(""), imageURL = _5[0], setImageURL = _5[1];
    var _6 = useState(false), isViewImageDrawerOpen = _6[0], setIsViewImageDrawerOpen = _6[1];
    var _7 = useState(false), viewAllImages = _7[0], setViewAllImages = _7[1];
    var _8 = useState(0), FIRejectedItemsCount = _8[0], setFIRejectedItemsCount = _8[1];
    var _9 = useState([]), suggestions = _9[0], setSuggestions = _9[1];
    var _10 = useState([]), futureAdviseList = _10[0], setFutureAdviseList = _10[1];
    var UCN_MAP_ELEMENT = getLocalStorageItem(LOCAL_STORAGE_KEYS.UCN_MAP);
    var UCN_ALLOWED_REPAIR_TYPES = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_SERVICE_TYPE.split(",") : [];
    var UCN_CODE_TRANSACTION_TYPES = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_TRANSACTION_TYPE.split(",") : [];
    var UCN_CODE_OPTION = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_OPTIONS : "OPTIONAL";
    var UCN_CODE_SOURCE = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_SOURCE : "";
    var IsSendUCNDisabled = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.IsSendUCNDisabled === "true" : false;
    var _11 = useState(null), existingUcnDetails = _11[0], setExistingUcnDetails = _11[1];
    var _12 = useState(existingUcnDetails && existingUcnDetails.UCNCouponCode ? existingUcnDetails.UCNCouponCode : ''), ucnCode = _12[0], setUcnCode = _12[1];
    var _13 = useState(false), showDeliveredDialog = _13[0], setShowDeliveredDialog = _13[1];
    var _14 = useState(ucnCode ? 'Remove' : IsSendUCNDisabled ? 'Check UCN' : UCN_CODE_SOURCE === 'SMS' ? 'Send' : "Apply"), ucnState = _14[0], setUcnState = _14[1];
    // const [isOdometerChange, setIsOdometerChange] = useState<boolean>(false);
    var _15 = useState(UCN_HELPER_TEXT_STATE.INFO), ucnHelperText = _15[0], setUcnHelperText = _15[1];
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var jobcardFeaturesFI = getCTAList(storedAllMenuFeatures, EMenuNames.FinalInspection);
    var isFI = (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector;
    var labourElements = useLabourElements();
    var partElements = usePartElements();
    var futureAdviseElements = useFutureAdviseElements();
    var drawerContainerProps = {
        anchor: "bottom",
        PaperProps: {
            sx: {
                width: {
                    xs: '90%',
                    sm: '400px'
                }
            }
        }
    };
    var updateDocumentStatus = function (statusName, statusKey) {
        dispatch(setState({
            key: 'documentDetailsGetById',
            value: _objectSpread(_objectSpread({}, documentDetailsGetById), {}, {
                data: _objectSpread(_objectSpread({}, documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data), {}, {
                    StatusName: statusName,
                    Key: statusKey
                })
            })
        }));
    };
    var socketRoom = "".concat(storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId, "_").concat(storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId);
    var socket = null;
    socket = socketIO;
    var syncJobcardStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy6, _documentDetailsGetBy7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy6 = documentDetailsGetById.data) !== null && _documentDetailsGetBy6 !== void 0 && _documentDetailsGetBy6.SourceDocumentNo))
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'syncJobCardStatus',
                            url: syncJobCardStatusURL,
                            request: {
                                SourceDocumentNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.SourceDocumentNo
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        syncJobcardStatus();
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.SourceDocumentNo]);
    useEffect(function () {
        var _documentDetailsGetBy9;
        setShowDeliveredDialog((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector && [StatusEnum.ReadyForInvoice, StatusEnum.Invoiced, StatusEnum.Delivered].includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.Key));
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.Key]);
    useEffect(function () {
        var _documentDetailsGetBy11;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy11 = documentDetailsGetById.data) !== null && _documentDetailsGetBy11 !== void 0 && _documentDetailsGetBy11.id) {
            var jobCardStatusList = [];
            var statusList_1 = getLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST);
            if (statusList_1 && statusList_1[ESystemName.Jobcard] && statusList_1[ESystemName.Jobcard].length > 0) {
                jobCardStatusList = statusList_1[ESystemName.Jobcard];
                console.log("matchedStatus", jobCardStatusList);
                console.log("documentDetailsGetById", documentDetailsGetById);
                var matchedStatus = jobCardStatusList.find(function (jobCardStatusItem) {
                    var _documentDetailsGetBy12;
                    return jobCardStatusItem.Key === (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.Key);
                });
                getJobCardStatus(matchedStatus === null || matchedStatus === void 0 ? void 0 : matchedStatus.StatusId);
            }
            if (documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && jobcardFeatures && jobcardFeatures.length > 0) {
                if ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === "ServiceAdvisor") {
                    menuListFeatureFunction(jobcardFeatures, documentDetailsGetById);
                }
            }
            else {
                menuListFeatureFunction(jobcardFeaturesFI, documentDetailsGetById);
            }
        }
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy13 = documentDetailsGetById.data) === null || _documentDetailsGetBy13 === void 0 ? void 0 : _documentDetailsGetBy13.id, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy14 = documentDetailsGetById.data) === null || _documentDetailsGetBy14 === void 0 ? void 0 : _documentDetailsGetBy14.Key]);
    var handleEmptyImage = function (item) {
        setAccidentalDetialsPhotographList([]);
    };
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    useEffect(function () {
        dispatch(resetState(["callReworkTabAPIS"]));
        dispatch(setState({
            key: "preDocumentFetch",
            value: []
        }));
        scrollToTop();
        checkRevisedEstimateAPICall();
        getWorkDistributionStatusList({
            request: {
                SystemName: "JobCardDetail"
            }
        });
        getUCNDetails();
        // customerComplaintJobcard({ JobCardId: id }, JCCustomerVoicesURL)
    }, []);
    var showReworkTabConditionBasedOnStatus = function () {
        if (progessSteps.length > 0) {
            var reworkStatus = progessSteps.find(function (step) { return step.key === "Rework"; });
            if (reworkStatus && (reworkStatus.isCompleted || reworkStatus.isActive || !!reworkStatus.DateTime)) {
                return true;
            }
        }
        return false;
    };
    var onClickStatusStepperIcon = function () {
        setOpenStatusProgress(true);
    };
    var getUCNDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: "UCNDetails",
                        url: getUCNByDocumentIdUrl,
                        request: {
                            ChildId: id
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    setUcnCode(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.UCNCouponCode);
                    return [2 /*return*/];
            }
        });
    }); };
    var getJobCardStatus = function (statusId) { return __awaiter(void 0, void 0, void 0, function () {
        var jobCardStatusList, _statusResponse$paylo, _statusResponse$paylo2, _statusResponse$paylo3, request, statusResponse, _statusResponse$paylo4, _statusResponse$paylo5, updatedStoredList, requestParams, result, jobCardProgressList_1, updatedSteps_1, stepsWithStatusId_1, currentStatusProgress, currentStatusProgressStep, sequencedSteps, unique, findRework, finalArray, activeStatus_1, filteredStatuses, _finalArray;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    jobCardStatusList = [];
                    if (!(statusList && statusList[ESystemName.Jobcard] && statusList[ESystemName.Jobcard].length > 0)) return [3 /*break*/, 1];
                    jobCardStatusList = statusList[ESystemName.Jobcard];
                    return [3 /*break*/, 3];
                case 1:
                    request = {
                        SystemName: ESystemName.Jobcard
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "statusList",
                            url: "".concat(Config.baseURL, "JobCard/BySystemName"),
                            request: request
                        }))];
                case 2:
                    statusResponse = _b.sent();
                    if ((statusResponse === null || statusResponse === void 0 || (_statusResponse$paylo = statusResponse.payload) === null || _statusResponse$paylo === void 0 || (_statusResponse$paylo = _statusResponse$paylo.value) === null || _statusResponse$paylo === void 0 ? void 0 : _statusResponse$paylo.statusCode) == 200 && statusResponse !== null && statusResponse !== void 0 && (_statusResponse$paylo2 = statusResponse.payload) !== null && _statusResponse$paylo2 !== void 0 && (_statusResponse$paylo2 = _statusResponse$paylo2.value) !== null && _statusResponse$paylo2 !== void 0 && _statusResponse$paylo2.success && statusResponse !== null && statusResponse !== void 0 && (_statusResponse$paylo3 = statusResponse.payload) !== null && _statusResponse$paylo3 !== void 0 && (_statusResponse$paylo3 = _statusResponse$paylo3.value) !== null && _statusResponse$paylo3 !== void 0 && _statusResponse$paylo3.data) {
                        jobCardStatusList = statusResponse === null || statusResponse === void 0 || (_statusResponse$paylo4 = statusResponse.payload) === null || _statusResponse$paylo4 === void 0 || (_statusResponse$paylo4 = _statusResponse$paylo4.value) === null || _statusResponse$paylo4 === void 0 ? void 0 : _statusResponse$paylo4.data;
                        updatedStoredList = _objectSpread(_objectSpread({}, statusList), {}, (_a = {},
                            _a[ESystemName.Jobcard] = statusResponse === null || statusResponse === void 0 || (_statusResponse$paylo5 = statusResponse.payload) === null || _statusResponse$paylo5 === void 0 || (_statusResponse$paylo5 = _statusResponse$paylo5.value) === null || _statusResponse$paylo5 === void 0 ? void 0 : _statusResponse$paylo5.data,
                            _a));
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST, updatedStoredList);
                    }
                    _b.label = 3;
                case 3:
                    requestParams = {
                        ParentId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: jobCardStatusProgressUrl,
                            request: requestParams
                        }))];
                case 4:
                    result = _b.sent();
                    if (result.payload.success && result.payload.data && result.payload.data.length > 0) {
                        jobCardProgressList_1 = result.payload.data;
                        updatedSteps_1 = [];
                        stepsWithStatusId_1 = [];
                        steps.map(function (item) {
                            var matchedStatus = jobCardStatusList.find(function (jobCardStatusItem) { return jobCardStatusItem.Key === item.key; });
                            if (matchedStatus) {
                                stepsWithStatusId_1.push(_objectSpread(_objectSpread({}, item), {}, {
                                    StatusId: matchedStatus === null || matchedStatus === void 0 ? void 0 : matchedStatus.StatusId,
                                    label: matchedStatus.DisplayName
                                }));
                            }
                        });
                        stepsWithStatusId_1.map(function (stepItem) {
                            var updatedItem = _objectSpread({}, stepItem);
                            var matchedStatus = jobCardStatusList.find(function (jobCardStatusItem) { return jobCardStatusItem.Key === stepItem.key; });
                            if (matchedStatus) {
                                updatedItem.label = matchedStatus.DisplayName;
                                var matchedProgress = jobCardProgressList_1.find(function (progressItem) { return matchedStatus.StatusId === progressItem.StatusId; });
                                if (matchedProgress) {
                                    updatedItem.isCompleted = true;
                                    updatedItem.isActive = false;
                                    updatedItem.DateTime = matchedProgress.DateTime;
                                }
                                else {
                                    updatedItem.isCompleted = false;
                                    updatedItem.isActive = false;
                                }
                            }
                            updatedSteps_1.push(updatedItem);
                        });
                        currentStatusProgress = jobCardProgressList_1.find(function (stepItem) { return stepItem.StatusId === statusId; });
                        currentStatusProgressStep = stepsWithStatusId_1.find(function (stepItem) { return stepItem.StatusId === statusId; });
                        if (currentStatusProgress && currentStatusProgressStep) {
                            updatedSteps_1.push(_objectSpread(_objectSpread({}, currentStatusProgress), {}, {
                                isCompleted: false,
                                isActive: true,
                                key: currentStatusProgress.Key,
                                Sequence: currentStatusProgressStep.Sequence,
                                label: currentStatusProgressStep.label,
                                DateTime: currentStatusProgress.DateTime
                            }));
                        }
                        else if (currentStatusProgressStep && !currentStatusProgress) {
                            updatedSteps_1.push(_objectSpread(_objectSpread({}, currentStatusProgressStep), {}, {
                                isCompleted: false,
                                isActive: true
                            }));
                        }
                        sequencedSteps = updatedSteps_1 === null || updatedSteps_1 === void 0 ? void 0 : updatedSteps_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        unique = Object.values(sequencedSteps.reduce(function (acc, obj) {
                            var _a;
                            return _objectSpread(_objectSpread({}, acc), {}, (_a = {},
                                _a[obj.key] = obj,
                                _a));
                        }, {}));
                        findRework = jobCardProgressList_1.find(function (progressItem) { return progressItem.Key === "Rework"; });
                        finalArray = unique;
                        if (!findRework) {
                            finalArray = unique === null || unique === void 0 ? void 0 : unique.filter(function (item) { return item.key !== "Rework"; });
                        }
                        activeStatus_1 = finalArray.find(function (status) { return status.isActive; });
                        filteredStatuses = finalArray;
                        if (activeStatus_1) {
                            filteredStatuses = (_finalArray = finalArray) === null || _finalArray === void 0 ? void 0 : _finalArray.filter(function (status) {
                                if ((status.isActive || status.isCompleted) && status.Sequence <= activeStatus_1.Sequence) {
                                    return true;
                                }
                                else if (status.Sequence > activeStatus_1.Sequence) {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            });
                        }
                        setProgressSteps(filteredStatuses);
                        // dispatch(showLoader({ isLoaderOpen: false }))
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRiderDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy15, _documentDetailsGetBy16, _response$payload, _response$payload2, response, _response$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy15 = documentDetailsGetById.data) !== null && _documentDetailsGetBy15 !== void 0 && _documentDetailsGetBy15.AssociateCustomerId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getAssociateCustomerUrl(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy16 = documentDetailsGetById.data) === null || _documentDetailsGetBy16 === void 0 ? void 0 : _documentDetailsGetBy16.AssociateCustomerId)
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        setRiderDetails(response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.data);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var jobcardFeatures = getCTAList(storedAllMenuFeatures, EMenuNames.Jobcard);
    var delayJobCardConfig = getLocalStorageItem(LOCAL_STORAGE_KEYS.DELAY_JOB_CARD_CONFIGURATION);
    function reduceArray(acc, cur, key) {
        var _cur$SavedPriceWithTa;
        var amount = (cur === null || cur === void 0 || (_cur$SavedPriceWithTa = cur.SavedPriceWithTax) === null || _cur$SavedPriceWithTa === void 0 ? void 0 : _cur$SavedPriceWithTa.Amount) || 0;
        return acc + amount;
    }
    var getFIChecklistCount = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var body, reworkCountResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id,
                        ChildId: productId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/ReworkItemCount"),
                            request: body
                        }))];
                case 1:
                    reworkCountResponse = _a.sent();
                    if (reworkCountResponse.payload.success && reworkCountResponse.payload.count) {
                        setFIRejectedItemsCount(reworkCountResponse.payload.count);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _documentDetailsGetBy17;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy17 = documentDetailsGetById.data) !== null && _documentDetailsGetBy17 !== void 0 && _documentDetailsGetBy17.id) {
            try {
                var _documentDetailsGetBy18, _documentDetailsGetBy19, _documentDetailsGetBy20, _documentDetailsGetBy22, _documentDetailsGetBy23, _documentDetailsGetBy24, _documentDetailsGetBy25, _documentDetailsGetBy26;
                getFIChecklistCount(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy18 = documentDetailsGetById.data) === null || _documentDetailsGetBy18 === void 0 ? void 0 : _documentDetailsGetBy18.ProductId);
                getRiderDetails();
                getJobCardStatus(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy19 = documentDetailsGetById.data) === null || _documentDetailsGetBy19 === void 0 ? void 0 : _documentDetailsGetBy19.StatusId);
                var difference = moment().diff(moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy20 = documentDetailsGetById.data) === null || _documentDetailsGetBy20 === void 0 ? void 0 : _documentDetailsGetBy20.EstimateDeliveryDateTime));
                var timeValidate = difference > 0;
                var statusValidate = true;
                if (delayJobCardConfig !== null && delayJobCardConfig !== void 0 && delayJobCardConfig.StatusKey) {
                    var minStep = steps.findIndex(function (item) { return item.key === (delayJobCardConfig === null || delayJobCardConfig === void 0 ? void 0 : delayJobCardConfig.StatusKey); });
                    var currentStep = steps.findIndex(function (item) {
                        var _documentDetailsGetBy21;
                        return item.key === (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy21 = documentDetailsGetById.data) === null || _documentDetailsGetBy21 === void 0 ? void 0 : _documentDetailsGetBy21.Key);
                    });
                    statusValidate = minStep > currentStep;
                }
                if (statusValidate && timeValidate && delayJobCardConfig !== null && delayJobCardConfig !== void 0 && delayJobCardConfig.IsPrompt) {
                    setAnchorElDelayedPopup(true);
                }
                getActiveAccidentalConfiguration(documentDetailsGetById.data.RepairTypeId);
                getDownloadImageAccidentallDetails((_documentDetailsGetBy22 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy23 = documentDetailsGetById.data) === null || _documentDetailsGetBy23 === void 0 || (_documentDetailsGetBy23 = _documentDetailsGetBy23.JobCardAccidentalDetail) === null || _documentDetailsGetBy23 === void 0 ? void 0 : _documentDetailsGetBy23.ImageAttachments) !== null && _documentDetailsGetBy22 !== void 0 ? _documentDetailsGetBy22 : []);
                switch (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) {
                    case EUserRole.ServiceAdvisor:
                    case EUserRole.FloorSupervisor:
                        menuListFeatureFunction(jobcardFeatures, documentDetailsGetById);
                        return;
                    case EUserRole.FinalInspector:
                        menuListFeatureFunction(jobcardFeaturesFI, documentDetailsGetById);
                        return;
                }
                var previousJobcardBody = {
                    InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy24 = documentDetailsGetById.data) === null || _documentDetailsGetBy24 === void 0 ? void 0 : _documentDetailsGetBy24.InstallBaseId,
                    Status: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy25 = documentDetailsGetById.data) !== null && _documentDetailsGetBy25 !== void 0 && _documentDetailsGetBy25.Key ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy26 = documentDetailsGetById.data) === null || _documentDetailsGetBy26 === void 0 ? void 0 : _documentDetailsGetBy26.Key : null
                };
                dispatch(createAPI({
                    key: "previousJobCards",
                    url: previousJobCardURLForRepeat,
                    request: previousJobcardBody
                })).then(function (result) {
                    var previousJcItem = result && result.payload && result.payload.value && result.payload.value.success && result.payload.value.data && Array.isArray(result.payload.value.data) && result.payload.value.data[0] ? result.payload.value.data[0] : null;
                    setPreviousJobcard(previousJcItem);
                });
            }
            catch (error) {
                console.error("Error fetching while setting up the jobcard:", error);
            }
        }
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy27 = documentDetailsGetById.data) === null || _documentDetailsGetBy27 === void 0 ? void 0 : _documentDetailsGetBy27.id]);
    useEffect(function () {
        if (CustomerVoiceData) {
            getDownloadImageCustomerVoice();
        }
    }, [CustomerVoiceData]);
    var getDownloadImageCustomerVoice = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _CustomerVoiceData$Im, _CustomerVoiceData$Im2, imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_1, sortedImages, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = CustomerVoiceData === null || CustomerVoiceData === void 0 || (_CustomerVoiceData$Im = CustomerVoiceData.ImageAttachment) === null || _CustomerVoiceData$Im === void 0 ? void 0 : _CustomerVoiceData$Im.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        base64: base64
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = CustomerVoiceData === null || CustomerVoiceData === void 0 || (_CustomerVoiceData$Im2 = CustomerVoiceData.ImageAttachment) === null || _CustomerVoiceData$Im2 === void 0 ? void 0 : _CustomerVoiceData$Im2.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (audioItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!audioItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(audioItem.AttachmentId, audioItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                        base64: base64
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_4 = _a.sent();
                                    console.error(error_4);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5:
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs);
                    setCustomerComplaintImagesList(sortedImages);
                    setCustomerComplaintAudiosList(audioAttachementURLs);
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    console.error("CustomerComplaintView :: getDownloadImageError :: ", error_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getDownloadImageAccidentallDetails = function (ImageAttachments) { return __awaiter(void 0, void 0, void 0, function () {
        var imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = ImageAttachments === null || ImageAttachments === void 0 ? void 0 : ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_6;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        isAlreadyUploaded: true,
                                        AttachmentId: imageItem.AttachmentId,
                                        ParentId: imageItem.ParentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_6 = _a.sent();
                                    console.error(error_6);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = ImageAttachments === null || ImageAttachments === void 0 ? void 0 : ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_7;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        AttachmentId: imageItem.AttachmentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_7 = _a.sent();
                                    console.error(error_7);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_5 = _a.sent();
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    console.error(error_5);
                    return [3 /*break*/, 5];
                case 5:
                    setAccidentalDetialsPhotographList(imageAttachementURLs);
                    setAccidentalDetialsAudioList(audioAttachementURLs);
                    return [2 /*return*/];
            }
        });
    }); };
    var getActiveAccidentalConfiguration = function (serviceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _Response$payload, request, Response, _Response$payload2, inputData, output_1, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        "ServiceTypeId": serviceTypeId,
                        ChannelId: storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId,
                        SystemName: 'JobCard'
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: GetActiveAccidentalConfigurationUrl,
                            request: request
                        }))];
                case 1:
                    Response = _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.data) {
                        inputData = _objectSpread({}, Response === null || Response === void 0 || (_Response$payload2 = Response.payload) === null || _Response$payload2 === void 0 || (_Response$payload2 = _Response$payload2.value) === null || _Response$payload2 === void 0 ? void 0 : _Response$payload2.data);
                        output_1 = {};
                        Object.entries(inputData).forEach(function (_ref) {
                            var category = _ref[0], fields = _ref[1];
                            fields === null || fields === void 0 || fields.forEach(function (field) {
                                var key = Object.keys(field)[0]; // Extract field name
                                if (key && key.trim()) {
                                    output_1[key] = {
                                        show: field[key],
                                        IsMandatory: field["IsMandatoryFor".concat(key)]
                                    };
                                }
                            });
                        });
                        setAccidentalDetailsConfig(output_1);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_8 = _a.sent();
                    console.error("Error fetching Active Accidental Configuration:", error_8);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleViewAllClick = function (items) {
        setViewAllImages(true);
    };
    var menuListFeatureFunction = function (featureList, row) {
        var _menusList2;
        var menusList = [];
        menusList = getFeaturesByStatusAndRbac(row === null || row === void 0 ? void 0 : row.data, rbacControl, serviceTypesData, featureList, selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name);
        if ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector) {
            var _row$data;
            if ([StatusEnum.InspectionCompleted, StatusEnum.ReadyForInvoice, StatusEnum.Invoiced, StatusEnum.Delivered].includes(row === null || row === void 0 || (_row$data = row.data) === null || _row$data === void 0 ? void 0 : _row$data.Key)) {
                var _menusList;
                menusList = (_menusList = menusList) === null || _menusList === void 0 ? void 0 : _menusList.filter(function (element) { return element.Name !== FIMenuFeatures.ReassignFinalInspector; });
            }
        }
        if (isMobile)
            (_menusList2 = menusList) === null || _menusList2 === void 0 || _menusList2.push({
                DisplayName: "Print",
                FeatureId: "print",
                FeatureAccesses: [],
                Name: "print",
                id: "print"
            });
        setMenus(menusList);
    };
    var handleBackClick = function () {
        // if (isDocDataUpdated) {    
        if (isdataAlter === true) {
            setIsUnsavedDataModalOpen(true);
        }
        else {
            navigate(parentModulePath);
            dispatch(setReducerState({
                key: getUpdateKey(JcKey.JcPaging),
                value: true
            }));
            dispatch(setReducerState({
                key: 'filterValue',
                value: null
            }));
        }
    };
    var handleBackToHomeClick = function () {
        setShowDeliveredDialog(false);
        navigate('/FinalInspection');
    };
    var handleClick = function (event) {
        trackButtonClick("ButtonClickEvent", "More_Icon_Click", undefined);
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    var handleMenusClick = function (data, state) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy28, _documentDetailsGetBy29, _documentDetailsGetBy30, _documentDetailsGetBy31, res, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setState({
                        key: "FIObservation",
                        value: {}
                    }));
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ViewTaskSummary || (data === null || data === void 0 ? void 0 : data.Name) === FIMenuFeatures.ViewTaskSummary)) return [3 /*break*/, 1];
                    setOpenTaskSummery(function (prev) { return !prev; });
                    return [3 /*break*/, 14];
                case 1:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ViewServiceEstimate || (data === null || data === void 0 ? void 0 : data.Name) === FIMenuFeatures.ViewServiceEstimate)) return [3 /*break*/, 2];
                    setOpenServiceEstimate(true);
                    return [3 /*break*/, 14];
                case 2:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.AssignFinalInspector)) return [3 /*break*/, 3];
                    setIsAssignFIModalOpen(true);
                    setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
                    return [3 /*break*/, 14];
                case 3:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ReassignFinalInspector || (data === null || data === void 0 ? void 0 : data.Name) === FIMenuFeatures.ReassignFinalInspector)) return [3 /*break*/, 4];
                    setIsAssignFIModalOpen(true);
                    setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
                    return [3 /*break*/, 14];
                case 4:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ReassignServiceAdvisor)) return [3 /*break*/, 5];
                    // setIsAssignModalOpen(true);
                    // setAssignValue(data?.Name)
                    dispatch(showSurface({
                        type: 'Dialog',
                        Component: ReassignServiceAdvisor,
                        componentProps: {
                            state: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data
                        },
                        containerProps: {
                            maxWidth: 'xs'
                        }
                    }));
                    return [3 /*break*/, 14];
                case 5:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.CreateNewSpareIssue)) return [3 /*break*/, 6];
                    dispatch(resetState(APIKeys));
                    navigate("/spareIssues/createSpareIssues/".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy28 = documentDetailsGetById.data) === null || _documentDetailsGetBy28 === void 0 ? void 0 : _documentDetailsGetBy28.JobCardId, "/").concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy29 = documentDetailsGetById.data) === null || _documentDetailsGetBy29 === void 0 ? void 0 : _documentDetailsGetBy29.OrganizationId, "?mode=create"));
                    return [3 /*break*/, 14];
                case 6:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ViewSpareIssue)) return [3 /*break*/, 7];
                    dispatch(resetState(APIKeys));
                    navigate("/spareIssues/createSpareIssues/".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy30 = documentDetailsGetById.data) === null || _documentDetailsGetBy30 === void 0 ? void 0 : _documentDetailsGetBy30.JobCardId, "/").concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy31 = documentDetailsGetById.data) === null || _documentDetailsGetBy31 === void 0 ? void 0 : _documentDetailsGetBy31.OrganizationId, "?mode=view"));
                    return [3 /*break*/, 14];
                case 7:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.ChangeServiceType)) return [3 /*break*/, 8];
                    setOpenServiceTypeModal(true);
                    return [3 /*break*/, 14];
                case 8:
                    if (!((data === null || data === void 0 ? void 0 : data.Name) === JCMenuFeatures.Cancel)) return [3 /*break*/, 13];
                    if (!IS_MOBILE) return [3 /*break*/, 10];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Drawer',
                            Component: NewCancelPopup,
                            componentProps: {
                                state: id
                            },
                            containerProps: {
                                anchor: "bottom",
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px 8px 0px 0px"
                                    }
                                }
                            }
                        }))];
                case 9:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && res.payload) {
                        navigate("/jobCard");
                    }
                    return [3 /*break*/, 12];
                case 10: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: NewCancelPopup,
                        componentProps: {
                            state: id
                        }
                        // containerProps: { anchor: "bottom" },
                    }))];
                case 11:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && res.payload) {
                        navigate("/jobCard");
                    }
                    _a.label = 12;
                case 12:
                    setIsCancelModalOpen(true);
                    return [3 /*break*/, 14];
                case 13:
                    if ((data === null || data === void 0 ? void 0 : data.Name) === 'print') {
                        openPrintOptionDrawer(state);
                    }
                    _a.label = 14;
                case 14: return [2 /*return*/];
            }
        });
    }); };
    var openPrintOptionDrawer = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var res, res_1, res_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Drawer',
                        Component: OptionPopup,
                        containerProps: {
                            anchor: "bottom",
                            PaperProps: {
                                sx: {
                                    borderRadius: '8px 8px 0 0'
                                }
                            }
                        },
                        componentProps: {
                            data: {
                                Title: 'Print',
                                options: [{
                                        id: 'print-customer',
                                        Name: 'CustomerPrint',
                                        DisplayName: 'JobCardPrint.pdf'
                                    }
                                    // { id: 'print-technician', Name: 'TechnicianPrint', DisplayName: 'TechnicianPrint.pdf' }
                                ]
                            }
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "CustomerPrint")) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Drawer',
                            Component: CombineJCPrint,
                            containerProps: {
                                anchor: "bottom",
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px 8px 0 0'
                                    }
                                }
                            },
                            componentProps: {
                                data: state
                            }
                        }))];
                case 2:
                    res_1 = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "TechnicianPrint")) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Drawer',
                            Component: TechnicianPrintPreview,
                            containerProps: {
                                anchor: "bottom",
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px 8px 0 0'
                                    }
                                }
                            },
                            componentProps: {
                                data: state
                            }
                        }))];
                case 4:
                    res_2 = _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var checkRevisedEstimateAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestParams, url, result, _result$payload, _result$payload2, _result$payload3, _result$payload4, _result$payload5, _result$payload6, _result$payload7, _result$payload8, _result$payload9, _result$payload12, _result$payload10, _result$payload11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestParams = {};
                    url = "";
                    if (Module === isModuleConfig.Bajaj) {
                        requestParams.ParentId = id;
                        url = RevisedEstimateIsExistUrl;
                    }
                    else {
                        requestParams.JobCardId = id;
                        url = EstimateCheckExistUrl;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'RevisedEstimateIsExist',
                            url: url,
                            request: requestParams
                        }))];
                case 1:
                    result = _a.sent();
                    if (Module === isModuleConfig.Bajaj) {
                        if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) == 200 && result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && _result$payload3.data && (result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.AdditionalJobs) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.length) > 0) {
                            setButtonName(true);
                        }
                        if (result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.success) {
                            setShowSkeleton(false);
                        }
                    }
                    else {
                        if (result !== null && result !== void 0 && (_result$payload6 = result.payload) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.value) !== null && _result$payload6 !== void 0 && _result$payload6.success && (result === null || result === void 0 || (_result$payload7 = result.payload) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.value) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.statusCode) == 200 && result !== null && result !== void 0 && (_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.value) !== null && _result$payload8 !== void 0 && _result$payload8.data && result !== null && result !== void 0 && (_result$payload9 = result.payload) !== null && _result$payload9 !== void 0 && (_result$payload9 = _result$payload9.value) !== null && _result$payload9 !== void 0 && (_result$payload9 = _result$payload9.data) !== null && _result$payload9 !== void 0 && _result$payload9.PreJobCardDocumentId) {
                            setRevisedEstimateId(result === null || result === void 0 || (_result$payload10 = result.payload) === null || _result$payload10 === void 0 || (_result$payload10 = _result$payload10.value) === null || _result$payload10 === void 0 || (_result$payload10 = _result$payload10.data) === null || _result$payload10 === void 0 ? void 0 : _result$payload10.PreJobCardDocumentId);
                            if ((result === null || result === void 0 || (_result$payload11 = result.payload) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.value) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.data) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.Jobs) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.length) > 0) {
                                setButtonName(true);
                            }
                        }
                        if (result !== null && result !== void 0 && (_result$payload12 = result.payload) !== null && _result$payload12 !== void 0 && (_result$payload12 = _result$payload12.value) !== null && _result$payload12 !== void 0 && _result$payload12.success) {
                            setShowSkeleton(false);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var AddNewJobsButtonBajaj = function () {
        var _RevisedEstimateIsExi;
        var preJobCardDocumentId = RevisedEstimateIsExist === null || RevisedEstimateIsExist === void 0 || (_RevisedEstimateIsExi = RevisedEstimateIsExist.data) === null || _RevisedEstimateIsExi === void 0 ? void 0 : _RevisedEstimateIsExi.PreJobCardDocumentId;
        if (preJobCardDocumentId) {
            dispatch(resetState(["ModuleDetailsGetById"]));
            navigate("/addNewJobs/".concat(id, "/").concat(preJobCardDocumentId));
        }
        else {
            dispatch(resetState(["ModuleDetailsGetById"]));
            navigate("/addNewJobs/".concat(id));
        }
    };
    var handleSuccess = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); };
    var onDrawerSEClick = function () {
        setOpenServiceEstimate(function (prev) { return !prev; });
    };
    var onViewEstimateClick = function () {
        var _documentDetailsGetBy32;
        dispatch(setState({
            key: "getModuleHeaderCount",
            value: []
        }));
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        onDrawerSEClick();
        navigate("/serviceEstimate-details/".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy32 = documentDetailsGetById.data) === null || _documentDetailsGetBy32 === void 0 ? void 0 : _documentDetailsGetBy32.ParentId), {
            state: {
                fromRoute: window.location.pathname
            }
        });
    };
    var onRevisedEstimateClick = function (PreJobCardDocumentId) {
        dispatch(setState({
            key: "getModuleHeaderCount",
            value: []
        }));
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        onDrawerSEClick();
        navigate("/reviseEstimate-details/RevisedEstimate/".concat(PreJobCardDocumentId, "/").concat(id), {
            state: {
                fromRoute: window.location.pathname
            }
        }); // prejobcard doucment id
    };
    var handleCloseDelayedPopup = function () {
        setAnchorElDelayedPopup(null);
    };
    var onDrawerClick = function () {
        setOpenTaskSummery(function (prev) { return !prev; });
    };
    var AddNewJobsButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var preJobCardDocumentId, _createRevisedEstimat, _createRevisedEstimat2, requestBody, createRevisedEstimateResponse, _createRevisedEstimat3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    preJobCardDocumentId = revisedEstimateId;
                    if (!preJobCardDocumentId) return [3 /*break*/, 1];
                    dispatch(resetState(["ModuleDetailsGetById"]));
                    navigate("/addNewJobs/".concat(id, "/").concat(preJobCardDocumentId));
                    return [3 /*break*/, 3];
                case 1:
                    requestBody = {
                        JobCardId: id
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: RevisedEstimateCreateUrl,
                            request: requestBody
                        }))];
                case 2:
                    createRevisedEstimateResponse = _a.sent();
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    if (createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat !== void 0 && _createRevisedEstimat.success && createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat2 = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat2 !== void 0 && (_createRevisedEstimat2 = _createRevisedEstimat2.data) !== null && _createRevisedEstimat2 !== void 0 && _createRevisedEstimat2.PreJobCardDocumentId) {
                        dispatch(resetState(["ModuleDetailsGetById"]));
                        navigate("/addNewJobs/".concat(id, "/").concat(createRevisedEstimateResponse === null || createRevisedEstimateResponse === void 0 || (_createRevisedEstimat3 = createRevisedEstimateResponse.payload) === null || _createRevisedEstimat3 === void 0 || (_createRevisedEstimat3 = _createRevisedEstimat3.data) === null || _createRevisedEstimat3 === void 0 ? void 0 : _createRevisedEstimat3.PreJobCardDocumentId));
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onCancelPopupClick = function (value) {
        setIsCancelModalOpen(value);
        setAnchorEl(null);
    };
    var onCanceljobCardClick = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload13, _result$payload14;
        return __generator(this, function (_a) {
            if ((result === null || result === void 0 || (_result$payload13 = result.payload) === null || _result$payload13 === void 0 ? void 0 : _result$payload13.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload14 = result.payload) !== null && _result$payload14 !== void 0 && _result$payload14.success) {
                dispatch(setState({
                    key: "menuValue",
                    value: 'cancel'
                }));
                onCancelPopupClick(false);
                dispatch(showNotification({
                    isOpen: true,
                    message: "Job card canceled successfully.",
                    type: "success"
                }));
                navigate("/jobCard");
            }
            return [2 /*return*/];
        });
    }); };
    var getSaveButtonDetails = function () {
        var ButtonDetails = {
            ButtonName: t('Save'),
            isDisabled: false
        };
        if ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === "FinalInspector") {
            var _documentDetailsGetBy33, _userData$data, _documentDetailsGetBy34, _userData$data2, _documentDetailsGetBy35, _documentDetailsGetBy36, _documentDetailsGetBy37;
            var isLoggedInUserIsAssignedFI = (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy33 = documentDetailsGetById.data) === null || _documentDetailsGetBy33 === void 0 ? void 0 : _documentDetailsGetBy33.FinalInspectorId) === (userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy34 = documentDetailsGetById.data) === null || _documentDetailsGetBy34 === void 0 ? void 0 : _documentDetailsGetBy34.FinalInspectorId) === (userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.EmployeeId);
            var isViewOnly = [StatusEnum.InspectionCompleted, StatusEnum.ReadyForInvoice, StatusEnum.Invoiced, StatusEnum.Delivered].includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy35 = documentDetailsGetById.data) === null || _documentDetailsGetBy35 === void 0 ? void 0 : _documentDetailsGetBy35.Key) || !isLoggedInUserIsAssignedFI;
            if (isViewOnly) {
                ButtonDetails.ButtonName = "View Inspection";
            }
            else if (["FinalInspection"].includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy36 = documentDetailsGetById.data) === null || _documentDetailsGetBy36 === void 0 ? void 0 : _documentDetailsGetBy36.Key)) {
                ButtonDetails.ButtonName = t("Start final inspection");
            }
            else if (["Rework"].includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy37 = documentDetailsGetById.data) === null || _documentDetailsGetBy37 === void 0 ? void 0 : _documentDetailsGetBy37.Key)) {
                ButtonDetails.ButtonName = t("Resume inspection");
            }
        }
        else {
            ButtonDetails.ButtonName = "Save";
            ButtonDetails.isDisabled = isDisabled;
        }
        return ButtonDetails;
    };
    var handleCancleClick = function (value) {
        setOpenUpload(value);
    };
    var handleConfirmClick = function (data) {
        // setComplaint({ ...complaint, images: data })
        setAccidentalDetialsPhotographList(data);
        // dispatch(setState({ key: "finalInspectorObservationDetails", value: { ...finalInspectorObservationDetails, images: data } }))
        // dispatch(setDocDataUpdated(true))
        // dispatch(setIsTaskDetailsDataUpdated(true))
        // if (isDataUpdated) {
        //     isDataUpdated(true)
        // }
    };
    var onClickRemovePhotoIcon = function (photoIndex, AttachmentId, parentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp, _DeleteAttchementResp2, DeleteAttchementResponse, updatedAttachmentList, updatedAttachmentList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!AttachmentId) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteAccidentalDetailsAttachment(parentId, AttachmentId)];
                case 1:
                    DeleteAttchementResponse = _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        updatedAttachmentList = __spreadArray([], accidentalDetailsPhotographList, true);
                        updatedAttachmentList.splice(photoIndex, 1);
                        setAccidentalDetialsPhotographList(updatedAttachmentList);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    updatedAttachmentList = __spreadArray([], accidentalDetailsPhotographList, true);
                    updatedAttachmentList.splice(photoIndex, 1);
                    setAccidentalDetialsPhotographList(updatedAttachmentList);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickImage = function (url) {
        setImageURL(url);
        setIsViewImageDrawerOpen(true);
    };
    var onConfirmClick = function (audio) {
        setAccidentalDetialsAudioList([{
                blobUrl: audio.audioBlobUrl,
                file: audio.audioFile,
                audioDuration: audio.audioDuration,
                AttachmentId: "",
                ParentId: ""
            }]);
    };
    var onDeleteRecording = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp3, _DeleteAttchementResp4, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accidentalDetailsAudioList[0]) return [3 /*break*/, 6];
                    if (!accidentalDetailsAudioList[0].AttachmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, deleteAccidentalDetailsAttachment(accidentalDetailsAudioList[0].ParentId, accidentalDetailsAudioList[0].AttachmentId)];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp3 = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp3 === void 0 || (_DeleteAttchementResp3 = _DeleteAttchementResp3.value) === null || _DeleteAttchementResp3 === void 0 ? void 0 : _DeleteAttchementResp3.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp4 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp4 !== void 0 && (_DeleteAttchementResp4 = _DeleteAttchementResp4.value) !== null && _DeleteAttchementResp4 !== void 0 && _DeleteAttchementResp4.success) {
                        setAccidentalDetialsAudioList([]);
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setAccidentalDetialsAudioList([]);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setAccidentalDetialsAudioList([]);
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var isUcnFieldDisabled = function () {
        var _documentDetailsGetBy38, _documentDetailsGetBy39, _documentDetailsGetBy40, _documentDetailsGetBy41;
        var result = true;
        var serviceTypeID = documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy38 = documentDetailsGetById.data) !== null && _documentDetailsGetBy38 !== void 0 && _documentDetailsGetBy38.RepairTypeId ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy39 = documentDetailsGetById.data) === null || _documentDetailsGetBy39 === void 0 ? void 0 : _documentDetailsGetBy39.RepairTypeId : "";
        var allowedDocumentStatuses = [StatusEnum.ReadyForWork, StatusEnum.Open, StatusEnum.WorkStarted, StatusEnum.WorkCompleted, StatusEnum.Rework, StatusEnum.Error];
        if (serviceTypeID && UCN_ALLOWED_REPAIR_TYPES.includes(serviceTypeID) && allowedDocumentStatuses.includes((_documentDetailsGetBy40 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy41 = documentDetailsGetById.data) === null || _documentDetailsGetBy41 === void 0 ? void 0 : _documentDetailsGetBy41.Key) !== null && _documentDetailsGetBy40 !== void 0 ? _documentDetailsGetBy40 : "")
            // (!isUcnAppliedSuccess)
            && ucnState !== 'Remove') {
            result = false;
        }
        return result;
    };
    var handleUcnButtonSubmit = function () {
        if (ucnState === 'Apply' && ucnCode === "") {
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', 'Please enter UCN.');
            dispatch(showNotification({
                isOpen: true,
                message: "Please enter UCN.",
                type: "error"
            }));
            return;
        }
        if (ucnState === 'Apply') {
            var _documentDetailsGetBy42, _documentDetailsGetBy43;
            var request = {
                "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy42 = documentDetailsGetById.data) === null || _documentDetailsGetBy42 === void 0 ? void 0 : _documentDetailsGetBy42.InstallBaseId,
                "ServiceTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy43 = documentDetailsGetById.data) === null || _documentDetailsGetBy43 === void 0 ? void 0 : _documentDetailsGetBy43.RepairTypeId,
                "SystemName": ESystemName.Jobcard,
                "ChildId": id,
                "UCNCouponCode": ucnCode
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            dispatch(createAPI({
                key: 'UCN',
                url: ApllyUCN,
                request: request
            })).then(function (response) {
                var _response$payload4, _response$payload5, _response$payload6;
                if ((response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.value) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.statusCode) == 200 || (response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 || (_response$payload5 = _response$payload5.value) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload6 = response.payload) !== null && _response$payload6 !== void 0 && (_response$payload6 = _response$payload6.value) !== null && _response$payload6 !== void 0 && _response$payload6.success) {
                    var _response$payload7;
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.APPLY_SUCCESS);
                    setUcnState('Remove');
                    setExistingUcnDetails(response === null || response === void 0 || (_response$payload7 = response.payload) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.value) === null || _response$payload7 === void 0 ? void 0 : _response$payload7.data);
                    // setUsUcnAppliedSuccess(true);
                }
                else {
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.ERROR);
                }
            }).catch(function () {
                setUcnHelperText(UCN_HELPER_TEXT_STATE.ERROR);
            }).finally(function () {
                // dispatch(showLoader({ isLoaderOpen: false }));
            }); //getCustomerInfo?.data?.Person?.GivenName 
        }
        if (ucnState === 'Send' || ucnState === 'Resend' || ucnState === 'Check UCN') {
            var _documentDetailsGetBy44, _documentDetailsGetBy45, _documentDetailsGetBy46, _documentDetailsGetBy47, _getMobileNumber, _documentDetailsGetBy48, _getMobileNumber2, _documentDetailsGetBy49, _documentDetailsGetBy50, _documentDetailsGetBy51, _documentDetailsGetBy52, _documentDetailsGetBy53;
            var request = {
                "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy44 = documentDetailsGetById.data) === null || _documentDetailsGetBy44 === void 0 ? void 0 : _documentDetailsGetBy44.InstallBaseId,
                "ServiceTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy45 = documentDetailsGetById.data) === null || _documentDetailsGetBy45 === void 0 ? void 0 : _documentDetailsGetBy45.RepairTypeId,
                "MobileNumber": documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy46 = documentDetailsGetById.data) !== null && _documentDetailsGetBy46 !== void 0 && _documentDetailsGetBy46.Customer && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy47 = documentDetailsGetById.data) !== null && _documentDetailsGetBy47 !== void 0 && (_documentDetailsGetBy47 = _documentDetailsGetBy47.Customer) !== null && _documentDetailsGetBy47 !== void 0 && _documentDetailsGetBy47.PersonContactPoint && (_getMobileNumber = getMobileNumber(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy48 = documentDetailsGetById.data) === null || _documentDetailsGetBy48 === void 0 || (_documentDetailsGetBy48 = _documentDetailsGetBy48.Customer) === null || _documentDetailsGetBy48 === void 0 ? void 0 : _documentDetailsGetBy48.PersonContactPoint, EContactType.Primary)) !== null && _getMobileNumber !== void 0 && _getMobileNumber.MobileNumber ? (_getMobileNumber2 = getMobileNumber(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy49 = documentDetailsGetById.data) === null || _documentDetailsGetBy49 === void 0 || (_documentDetailsGetBy49 = _documentDetailsGetBy49.Customer) === null || _documentDetailsGetBy49 === void 0 ? void 0 : _documentDetailsGetBy49.PersonContactPoint, EContactType.Primary)) === null || _getMobileNumber2 === void 0 ? void 0 : _getMobileNumber2.MobileNumber : "",
                "ServiceTypeName": documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy50 = documentDetailsGetById.data) !== null && _documentDetailsGetBy50 !== void 0 && _documentDetailsGetBy50.RepairTypeName ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy51 = documentDetailsGetById.data) === null || _documentDetailsGetBy51 === void 0 ? void 0 : _documentDetailsGetBy51.RepairTypeName : "",
                "ChassisNo": documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && documentDetailsGetById.data && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy52 = documentDetailsGetById.data) !== null && _documentDetailsGetBy52 !== void 0 && _documentDetailsGetBy52.VinNo ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy53 = documentDetailsGetById.data) === null || _documentDetailsGetBy53 === void 0 ? void 0 : _documentDetailsGetBy53.VinNo : ""
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            var errorOccurred_1 = false;
            dispatch(createAPI({
                url: SendUcnCodeUrl,
                request: request
            })).then(function (response) {
                var _response$payload8, _response$payload9, _response$payload10;
                if ((response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.statusCode) == 200 || (response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload10 = response.payload) !== null && _response$payload10 !== void 0 && _response$payload10.success) {
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.CODE_SENT);
                }
                else {
                    errorOccurred_1 = true;
                }
            }).finally(function () {
                if (!errorOccurred_1) {
                    setUcnState(function (prevState) {
                        if (prevState === 'Send' || prevState === 'Check UCN') {
                            prevState = 'Resend';
                        }
                        return prevState;
                    });
                }
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
        if (ucnState === 'Remove') {
            var request = {
                "ChildId": id,
                "UCNId": existingUcnDetails && existingUcnDetails.id ? existingUcnDetails.id : "",
                "SystemName": ESystemName.Jobcard,
                "UCNNo": ""
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            dispatch(createAPI({
                url: RemoveUcnUrl,
                request: request
            })).then(function (response) {
                var _response$payload11, _response$payload12, _response$payload13;
                if ((response === null || response === void 0 || (_response$payload11 = response.payload) === null || _response$payload11 === void 0 ? void 0 : _response$payload11.statusCode) == 200 || (response === null || response === void 0 || (_response$payload12 = response.payload) === null || _response$payload12 === void 0 ? void 0 : _response$payload12.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload13 = response.payload) !== null && _response$payload13 !== void 0 && _response$payload13.success) {
                    setUcnCode('');
                    setUcnState(IsSendUCNDisabled ? 'Apply' : UCN_CODE_SOURCE === 'SMS' ? 'Send' : "Apply");
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.INFO);
                    setExistingUcnDetails(null);
                }
            }).finally(function () {
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
    };
    var getUcnHelperText = function () {
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.ERROR) {
            return /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "sm",
                    fontWeight: 'medium'
                },
                color: 'error.main'
            }, "Invalid UCN.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.MADATORY) {
            return /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "sm",
                    fontWeight: 'medium'
                },
                color: 'error.main'
            }, "UCN code is mandatory.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.CODE_SENT) {
            var _documentDetailsGetBy54, _documentDetailsGetBy55;
            var mobileNumber = (_documentDetailsGetBy54 = documentDetailsGetById.data) !== null && _documentDetailsGetBy54 !== void 0 && _documentDetailsGetBy54.Customer && (_documentDetailsGetBy55 = documentDetailsGetById.data) !== null && _documentDetailsGetBy55 !== void 0 && (_documentDetailsGetBy55 = _documentDetailsGetBy55.Customer) !== null && _documentDetailsGetBy55 !== void 0 && _documentDetailsGetBy55.PersonContactPoint && getMobileNumber(documentDetailsGetById.data.Customer.PersonContactPoint, EContactType.Primary) ? getMobileNumber(documentDetailsGetById.data.Customer.PersonContactPoint, EContactType.Primary) : "";
            if (!mobileNumber) {
                var _documentDetailsGetBy56, _documentDetailsGetBy57;
                mobileNumber = (_documentDetailsGetBy56 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy57 = documentDetailsGetById.data) === null || _documentDetailsGetBy57 === void 0 ? void 0 : _documentDetailsGetBy57.MobileNumber) !== null && _documentDetailsGetBy56 !== void 0 ? _documentDetailsGetBy56 : null;
            }
            return Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "small",
                    fontWeight: "medium"
                },
                color: 'text.tertiary'
            }, "UCN Sent") : /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "small",
                    fontWeight: "medium"
                },
                color: 'text.tertiary'
            }, "UCN has been sent on ".concat(mobileNumber, " number"));
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.APPLY_SUCCESS) {
            return Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "small",
                    fontWeight: "medium"
                },
                color: 'success.main'
            }, "UCN Verified") : /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: "small",
                    fontWeight: "medium"
                },
                color: 'success.main'
            }, "UCN has successfully applied.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.INFO && ucnState === "Apply") {
            return null;
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.INFO && ucnState === "Remove") {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: "small",
                fontWeight: "medium"
            },
            color: 'text.tertiary'
        }, IsSendUCNDisabled ? 'Click to enter UCN' : "Click on send to get UCN");
    };
    var isUcnButtonDisbaled = function () {
        var _documentDetailsGetBy58, _documentDetailsGetBy59, _documentDetailsGetBy60;
        var result = true;
        var allowedDocumentStatuses = [StatusEnum.ReadyForWork, StatusEnum.Open, StatusEnum.WorkStarted, StatusEnum.WorkCompleted, StatusEnum.Rework, StatusEnum.Error];
        var serviceTypeID = documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy58 = documentDetailsGetById.data) !== null && _documentDetailsGetBy58 !== void 0 && _documentDetailsGetBy58.RepairTypeId ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy59 = documentDetailsGetById.data) === null || _documentDetailsGetBy59 === void 0 ? void 0 : _documentDetailsGetBy59.RepairTypeId : "";
        if (serviceTypeID && UCN_ALLOWED_REPAIR_TYPES.includes(serviceTypeID) && allowedDocumentStatuses.includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy60 = documentDetailsGetById.data) === null || _documentDetailsGetBy60 === void 0 ? void 0 : _documentDetailsGetBy60.Key)) {
            result = false;
        }
        return result;
    };
    var REVISED_ESTIMATE_BTN = (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.ServiceAdvisor || (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FloorSupervisor ? {
        type: FormItemTypes.Button,
        name: 'add-job-items',
        variant: 'outlined',
        disabled: isDisabled,
        children: buttonName ? t("View jobs") : t("Revise estimate"),
        columnSize: 0,
        onClick: Module === isModuleConfig.Bajaj ? AddNewJobsButtonBajaj : AddNewJobsButton
    } : null;
    var SAVE_BTN = (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) !== EUserRole.FinalInspector ? {
        type: FormItemTypes.Button,
        id: "createDocument",
        disabled: getSaveButtonDetails().isDisabled || crud[JobCardKeys.DisableSubmit],
        name: 'save-btn',
        children: getSaveButtonDetails().ButtonName,
        variant: 'contained',
        color: 'primary',
        columnSize: 0,
        // hidden: selectedDesignation?.Name === EUserRole.FinalInspector,
        onClick: function () {
            // Reset the unsaved data flag
            setIsdataAlter(false);
            // if (crud[getLoadingKey(JobCardKeys.ValidateQty)] === 'loading') return;
            return 'submit';
        },
        loading: crud[getLoadingKey(JobCardKeys.Update)] === 'loading'
    } : null;
    var START_FI_BTN = (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === EUserRole.FinalInspector ? {
        type: FormItemTypes.Button,
        id: "createDocument",
        disabled: getSaveButtonDetails().isDisabled,
        name: 'start-final-inspection-btn',
        children: getSaveButtonDetails().ButtonName,
        variant: 'contained',
        color: 'primary',
        columnSize: 0,
        // hidden: (selectedDesignation?.Name !== EUserRole.FinalInspector),
        onClick: function (e, state, api) {
            if (documentDetailsGetById.success) {
                var _documentDetailsGetBy61;
                navigate("/finalInspection-taskDetails/".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy61 = documentDetailsGetById.data) === null || _documentDetailsGetBy61 === void 0 ? void 0 : _documentDetailsGetBy61.JobCardId));
            }
        }
    } : null;
    var customerComplaintJobcard = function (request, customerComplaintUrl) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload14, _response$payload15, response, _response$payload16, _response$payload17, finalList, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'CustomerComplaintList',
                            url: customerComplaintUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload14 = response.payload) !== null && _response$payload14 !== void 0 && (_response$payload14 = _response$payload14.value) !== null && _response$payload14 !== void 0 && _response$payload14.statusCode && response !== null && response !== void 0 && (_response$payload15 = response.payload) !== null && _response$payload15 !== void 0 && (_response$payload15 = _response$payload15.value) !== null && _response$payload15 !== void 0 && _response$payload15.data) {
                        if ((response === null || response === void 0 || (_response$payload16 = response.payload) === null || _response$payload16 === void 0 || (_response$payload16 = _response$payload16.value) === null || _response$payload16 === void 0 || (_response$payload16 = _response$payload16.data) === null || _response$payload16 === void 0 ? void 0 : _response$payload16.CustomerVoice.length) > 0) {
                            finalList = response === null || response === void 0 || (_response$payload17 = response.payload) === null || _response$payload17 === void 0 || (_response$payload17 = _response$payload17.value) === null || _response$payload17 === void 0 || (_response$payload17 = _response$payload17.data) === null || _response$payload17 === void 0 ? void 0 : _response$payload17.CustomerVoice.map(function (list) {
                                var imageAttachementURLs = [];
                                return _objectSpread(_objectSpread({}, list), {}, {
                                    imageAttachementURLs: imageAttachementURLs,
                                    isExpanded: false
                                });
                            });
                            setList(finalList);
                        }
                    }
                    else {
                        // await dispatch(showLoader({ isLoaderOpen: false }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_9 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onClickYesBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // trackButtonClick("ButtonClickEvent", "OnYesClick", undefined);
            dispatch(setReducerState({
                key: getUpdateKey(JcKey.JcPaging),
                value: true
            }));
            setIsUnsavedDataModalOpen(false);
            return [2 /*return*/];
        });
    }); };
    var onClickNoBtn = function () {
        // trackButtonClick("ButtonClickEvent", "OnNoClickButton", undefined);
        // dispatch(
        //     resetState([
        //         "UCNDetails",
        //         "customerDetailsTrnalsteToJob",
        //         "preDocumentFetch",
        //         "customerComplaintDataImageAndAudio",
        //     ])
        // );
        setIsUnsavedDataModalOpen(false);
        navigate(parentModulePath);
    };
    var inputFieldTypes = new Set([FormItemTypes.TextInput, FormItemTypes.SearchSelect, FormItemTypes.SingleSelect, FormItemTypes.NumberInput, FormItemTypes.CheckBox, FormItemTypes.DatePicker, FormItemTypes.TimePicker, FormItemTypes.DateTimePicker, FormItemTypes.DateRangePicker, FormItemTypes.Password, FormItemTypes.Attachment]);
    var generalFields = [{
            type: FormItemTypes.CardComponent,
            name: 'general',
            columnSize: 12,
            sx: {
                py: {
                    xs: '2px',
                    sm: '6px'
                }
            },
            elements: [{
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: function (_ref2) {
                        var value = _ref2.value;
                        return /*#__PURE__*/ React.createElement(CustomerAndVehicleInfo, {
                            parentDocument: EParentModuleName.Jobcard,
                            VehiclesDetailsList: documentDetailsGetById ? [documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data] : [],
                            customerDetails: documentDetailsGetById ? documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data : {},
                            isCheckBoxVisible: false,
                            createAndEditFlow: {
                                isJobCard: "Update"
                            },
                            getNPS: function () { return value === null || value === void 0 ? void 0 : value.NPSResponse; }
                        });
                    }
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Rider Details',
            name: 'RiderDetails',
            value: null,
            columnSize: 12,
            // sx: { mb: '16px' },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            color: 'text.primary',
                            fontSize: 'base',
                            fontWeight: 'medium',
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                return "".concat(riderDetails !== null && riderDetails !== void 0 && riderDetails.GivenName ? riderDetails === null || riderDetails === void 0 ? void 0 : riderDetails.GivenName : "-", " ").concat(riderDetails !== null && riderDetails !== void 0 && riderDetails.FamilyName ? riderDetails === null || riderDetails === void 0 ? void 0 : riderDetails.FamilyName : "");
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            color: 'text.secondary',
                            fontSize: 'sm',
                            columnSize: 0,
                            fontWeight: 'normal',
                            valueGetter: function (formValues, field) {
                                return riderDetails !== null && riderDetails !== void 0 && riderDetails.RelationName ? riderDetails === null || riderDetails === void 0 ? void 0 : riderDetails.RelationName : "-";
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                return riderDetails !== null && riderDetails !== void 0 && riderDetails.MobileNumber ? riderDetails === null || riderDetails === void 0 ? void 0 : riderDetails.MobileNumber : "-";
                            }
                        }, {
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: 0,
                            element: function () { /*#__PURE__*/ return React.createElement("img", {
                                src: GreenVerifiedTick,
                                alt: "phoneIcon"
                            }); },
                            hidden: !(riderDetails !== null && riderDetails !== void 0 && riderDetails.IsMobileVerified)
                        }]
                }],
            hidden: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy62 = documentDetailsGetById.data) !== null && _documentDetailsGetBy62 !== void 0 && _documentDetailsGetBy62.AssociateCustomerId ? false : true
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Service Details',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    label: 'Service type',
                    name: 'RepairTypeName',
                    placeholder: 'Select service type',
                    required: true,
                    disabled: true
                },
                // {
                //     type: FormItemTypes.Box,
                //     name: '',
                //     xs: 12,
                //     sm: 6,
                //     md: 3,
                //     lg: 3,
                //     sx: { marginTop: '-10px' },
                //     elements: [
                //         {
                //             type: FormItemTypes.Box,
                //             name: '',
                //             display: 'flex',
                //             justifyContent: 'space-between',
                //             columnSize: 12,
                //             alignItems: 'center',
                //             elements: [
                //                 {
                //                     type: FormItemTypes.Typography,
                //                     name: '',
                //                     value: 'Odometer reading',
                //                     columnSize: true,
                //                     color: 'text.secondary',
                //                     fontSize: 'sm',
                //                     fontWeight: 'medium',
                //                     whiteSpace: 'nowrap',
                //                 },
                //                 {
                //                     type: FormItemTypes.CheckBox,
                //                     name: 'IsOdometerChange',
                //                     label: 'Odometer change',
                //                     columnSize: 0,
                //                     labelTypographyProps: {
                //                         fontSize: 'sm'
                //                     },
                //                     inputProps: {
                //                         id: 'odometer-change-checkbox'
                //                     },
                //                     formControlLabelProps: {
                //                         labelPlacement: 'start',
                //                         sx: {
                //                             color: 'text.secondary',
                //                             fontWeight: 'medium',
                //                             mx: 0,
                //                         }
                //                     },
                //                     sx: { p: 0.75 },
                //                     valueSetter: async (formValues, currValue, field) => {
                //                         const prevValue = formValues?.field;
                //                         if (prevValue === currValue) {
                //                             return formValues;
                //                         }
                //                         if (currValue === true) {
                //                             const result = await dispatch(showSurface({
                //                                 type: 'Dialog',
                //                                 Component: OdometerChangePopup,
                //                                 containerProps: {
                //                                     fullWidth: true,
                //                                     PaperProps: {
                //                                         sx: {
                //                                             borderRadius: '12px',
                //                                             width: {
                //                                                 sm: '350px',
                //                                                 md: '450px',
                //                                                 lg: '450px',
                //                                             }
                //                                         }
                //                                     }
                //                                 }
                //                             }));
                //                             return { IsOdometerChange: result?.payload === true };
                //                         }
                //                         return { IsOdometerChange: false };
                //                     },
                //                     valueGetter: (formValues) => {
                //                         return formValues?.IsOdometerChange || false;
                //                     }
                //                 }
                //             ],
                //         },
                //     ],
                // },
                {
                    type: FormItemTypes.NumberInput,
                    label: 'Odometer reading',
                    name: 'ODOMeterReading',
                    required: true,
                    disabled: true
                }, {
                    type: FormItemTypes.DateTimePicker,
                    label: 'Estimated delivery time',
                    name: 'EstimateDeliveryDateTime',
                    required: true,
                    disabled: true,
                    format: "DD MMM, YYYY hh:mm a",
                    timezone: "system"
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Work allocation',
            name: 'Workallocation',
            value: null,
            columnSize: 12,
            // sx: { mb: '16px' },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    label: 'Service advisor',
                    name: 'AssignedEmployeeId',
                    getListData: getServiceAdvisorAPICall,
                    apiKey: 'serviceAdvisorList',
                    apiRequest: {
                        BranchId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy63 = documentDetailsGetById.data) === null || _documentDetailsGetBy63 === void 0 ? void 0 : _documentDetailsGetBy63.OrganizationId
                    },
                    displayExpr: 'FirstName',
                    valueExpr: 'IdentityId',
                    required: true,
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.GivenName) + " " + (option === null || option === void 0 ? void 0 : option.FamilyName); },
                    disabled: true
                    // valueGetter:(state) => `${state.GivenName} ${state.FamilyName}`
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Assign technician',
                    name: 'TechnicianId',
                    // options: technicianList || [],
                    getListData: getTechnicianList,
                    apiKey: 'technicianList',
                    apiRequest: {
                        WorkingOrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy64 = documentDetailsGetById.data) === null || _documentDetailsGetBy64 === void 0 ? void 0 : _documentDetailsGetBy64.OrganizationId
                    },
                    disabled: isDisabled,
                    valueExpr: 'id',
                    getOptionLabel: function (data) { return data.FirstName + " " + data.LastName; },
                    valueSetter: function (state, currValue, field) {
                        var _state$labourDetails;
                        var isWorkStarted = state === null || state === void 0 || (_state$labourDetails = state.labourDetails) === null || _state$labourDetails === void 0 ? void 0 : _state$labourDetails.some(function (val) { return (val === null || val === void 0 ? void 0 : val.StatusName) === StatusEnum.Completed; });
                        if ((SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) !== E_Channel_Name.CV && isWorkStarted) {
                            if (state !== null && state !== void 0 && state.TechnicianId)
                                if ((currValue === null || currValue === void 0 ? void 0 : currValue.EmployeeId) !== (state === null || state === void 0 ? void 0 : state.TechnicianId) || isWorkStarted) {
                                    dispatch(showError("You cannot change 'Technician' since work is already Completed"));
                                }
                            if (!(state !== null && state !== void 0 && state.TechnicianId))
                                if ((currValue === null || currValue === void 0 ? void 0 : currValue.EmployeeId) !== (state === null || state === void 0 ? void 0 : state.TechnicianId) || isWorkStarted) {
                                    dispatch(showError("You cannot assign the 'Technician' since work is already Completed"));
                                }
                            return {
                                TechnicianId: state === null || state === void 0 ? void 0 : state.TechnicianId
                            };
                        }
                        return {
                            TechnicianId: currValue === null || currValue === void 0 ? void 0 : currValue.id
                        };
                    },
                    validator: function (value, state) {
                        if (state !== null && state !== void 0 && state.IsTechnicianAssigned && !value) {
                            return 'Header technician can be changed but not removed once assigned.';
                        }
                        return '';
                    },
                    setFormState: function (formValues, currValue, field) {
                        var _formValues$labourDet, _formValues$partDetai, _formValues$labourDet3, _formValues$labourDet4, _formValues$labourDet5;
                        if (!(formValues !== null && formValues !== void 0 && formValues.IsTechnicianAssigned) && !currValue) {
                            return {
                                PrevTechnician: currValue
                            };
                        }
                        var updatedLabourDetails = (_formValues$labourDet = formValues.labourDetails) === null || _formValues$labourDet === void 0 ? void 0 : _formValues$labourDet.map(function (labour) {
                            var _formValues$labourDet2, _getStatus, _getStatus2;
                            if (labour !== null && labour !== void 0 && labour.TechnicianId)
                                return labour;
                            var isWorkStarted = formValues === null || formValues === void 0 || (_formValues$labourDet2 = formValues.labourDetails) === null || _formValues$labourDet2 === void 0 ? void 0 : _formValues$labourDet2.some(function (val) { return (val === null || val === void 0 ? void 0 : val.StatusName) === StatusEnum.Completed; });
                            var isLabourAwaiting = (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) !== E_Channel_Name.CV && !(labour !== null && labour !== void 0 && labour.TechnicianName) && (labour === null || labour === void 0 ? void 0 : labour.StatusName) === StatusEnum.Awaiting;
                            var isWorkCompleted = (currValue === null || currValue === void 0 ? void 0 : currValue.EmployeeId) === (formValues === null || formValues === void 0 ? void 0 : formValues.TechnicianId) || !isWorkStarted;
                            return _objectSpread(_objectSpread({}, labour), {}, {
                                ServiceStartDateTime: isWorkCompleted && isLabourAwaiting ? dayjs() : labour === null || labour === void 0 ? void 0 : labour.ServiceStartDateTime,
                                StatusName: isWorkCompleted && isLabourAwaiting ? StatusEnum.Started : labour === null || labour === void 0 ? void 0 : labour.StatusName,
                                StatusId: isWorkCompleted && isLabourAwaiting ? (_getStatus = getStatus(StatusEnum.Started)) === null || _getStatus === void 0 ? void 0 : _getStatus.id : (_getStatus2 = getStatus(labour === null || labour === void 0 ? void 0 : labour.StatusName)) === null || _getStatus2 === void 0 ? void 0 : _getStatus2.id,
                                TechnicianFamilyName: isWorkCompleted ? currValue === null || currValue === void 0 ? void 0 : currValue.LastName : null,
                                TechnicianName: isWorkCompleted ? currValue === null || currValue === void 0 ? void 0 : currValue.FirstName : null,
                                TechnicianId: isWorkCompleted ? currValue === null || currValue === void 0 ? void 0 : currValue.id : null
                            });
                        });
                        var updatedPartDetails = formValues === null || formValues === void 0 || (_formValues$partDetai = formValues.partDetails) === null || _formValues$partDetai === void 0 ? void 0 : _formValues$partDetai.map(function (part) {
                            var _currValue$id;
                            if (part !== null && part !== void 0 && part.TechnicianId)
                                return part;
                            return _objectSpread(_objectSpread({}, part), {}, {
                                TechnicianName: currValue === null || currValue === void 0 ? void 0 : currValue.FirstName,
                                TechnicianFamilyName: currValue === null || currValue === void 0 ? void 0 : currValue.LastName,
                                TechnicianId: (_currValue$id = currValue === null || currValue === void 0 ? void 0 : currValue.id) !== null && _currValue$id !== void 0 ? _currValue$id : null
                            });
                        });
                        var isWorkCompleted = (_formValues$labourDet3 = formValues.labourDetails) === null || _formValues$labourDet3 === void 0 ? void 0 : _formValues$labourDet3.some(function (val) { return (val === null || val === void 0 ? void 0 : val.StatusName) === StatusEnum.Completed; });
                        var isReadyForWork = (_formValues$labourDet4 = formValues.labourDetails) === null || _formValues$labourDet4 === void 0 ? void 0 : _formValues$labourDet4.every(function (val) { return (val === null || val === void 0 ? void 0 : val.StatusName) === StatusEnum.Awaiting; });
                        // const isLabourDeleted = formValues?.labourDetails?.every((item: ResponseObject) => item.IsDeleted && !item.IsActive);
                        var newStatusName = !isWorkCompleted && !(formValues !== null && formValues !== void 0 && (_formValues$labourDet5 = formValues.labourDetails) !== null && _formValues$labourDet5 !== void 0 && _formValues$labourDet5.length) ? StatusEnum.Open : (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) !== E_Channel_Name.CV && !isWorkCompleted && !(formValues !== null && formValues !== void 0 && formValues.TechnicianId) ? "Work In Progress" : formValues === null || formValues === void 0 ? void 0 : formValues.StatusName;
                        var newStatusKey = !currValue ? StatusEnum.ReadyForWork : (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) !== E_Channel_Name.CV && !isWorkCompleted && !(formValues !== null && formValues !== void 0 && formValues.TechnicianId) ? StatusEnum.WorkStarted : formValues === null || formValues === void 0 ? void 0 : formValues.Key;
                        // updateDocumentStatus(newStatusName, newStatusKey);
                        return {
                            labourDetails: updatedLabourDetails,
                            partDetails: updatedPartDetails
                            // StatusName: newStatusName,
                            // Key: newStatusKey
                        };
                    },
                    displayExpr: 'FirstName'
                    // required: true,
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Final inspector',
                    name: 'FinalInspectorId',
                    getListData: getFinalInspectorListAPICall,
                    apiKey: 'getFinalInspectorList',
                    apiRequest: {
                        WorkingOrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy65 = documentDetailsGetById.data) === null || _documentDetailsGetBy65 === void 0 ? void 0 : _documentDetailsGetBy65.OrganizationId
                    },
                    displayExpr: 'FirstName',
                    valueExpr: 'FinalInspectorId',
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName); },
                    disabled: true
                    // required: true,
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Floor supervisor',
                    name: 'FloorSupervisorId',
                    getListData: floorSupervisorListAPICall,
                    apiKey: 'floorSupervisor',
                    apiRequest: {
                        WorkingOrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy66 = documentDetailsGetById.data) === null || _documentDetailsGetBy66 === void 0 ? void 0 : _documentDetailsGetBy66.OrganizationId
                    },
                    valueExpr: 'FloorSupervisorId',
                    disabled: isDisabled,
                    displayExpr: 'FirstName',
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName); }
                    // required: true,
                }, (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === E_Channel_Name.CV ? {
                    type: FormItemTypes.SearchSelect,
                    label: 'Assign bay',
                    name: 'ServiceStationId',
                    getListData: assignBayListAPICall,
                    apiRequest: {
                        OrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy67 = documentDetailsGetById.data) === null || _documentDetailsGetBy67 === void 0 ? void 0 : _documentDetailsGetBy67.OrganizationId
                    },
                    apiKey: 'assignBayList',
                    displayExpr: 'OrganizationServiceStationName',
                    valueExpr: 'id',
                    disabled: isDisabled,
                    required: true
                } : null]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Accident Details',
            name: 'AccidentDetails',
            value: null,
            columnSize: 12,
            hidden: !accidentalDetailsConfig || ((_Object$keys = Object.keys(accidentalDetailsConfig)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0 || accidentalDetailsFields.every(function (field) {
                var _accidentalDetailsCon;
                return (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon = accidentalDetailsConfig[field]) === null || _accidentalDetailsCon === void 0 ? void 0 : _accidentalDetailsCon.show) === false;
            }),
            elements: [accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon2 = accidentalDetailsConfig.AccidentDateTime) !== null && _accidentalDetailsCon2 !== void 0 && _accidentalDetailsCon2.show ? {
                    type: FormItemTypes.DateTimePicker,
                    name: 'AccidentDate',
                    label: 'Date & Time of Accident',
                    placeholder: 'Select Date & Time of Accident',
                    disabled: isDisabled,
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon3 = accidentalDetailsConfig.AccidentDateTime) === null || _accidentalDetailsCon3 === void 0 ? void 0 : _accidentalDetailsCon3.IsMandatory,
                    maxDateTime: dayjs(),
                    disableFuture: true,
                    validator: function (value) {
                        // Prevent selecting a future date/time
                        if (value && dayjs(value).isAfter(dayjs())) {
                            return "Please enter a valid date (no future date).";
                        }
                        return undefined;
                    }
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon4 = accidentalDetailsConfig.IntimationDateTime) !== null && _accidentalDetailsCon4 !== void 0 && _accidentalDetailsCon4.show ? {
                    type: FormItemTypes.DatePicker,
                    name: 'IntimationDate',
                    label: 'Date & Time of Intimation',
                    placeholder: 'Select Date & Time of Intimation',
                    disabled: isDisabled,
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon5 = accidentalDetailsConfig.IntimationDateTime) === null || _accidentalDetailsCon5 === void 0 ? void 0 : _accidentalDetailsCon5.IsMandatory,
                    disablePast: true,
                    validator: function (value) {
                        if (value && dayjs(value).isBefore(dayjs().startOf('day'))) {
                            return "Please enter a valid date (not earlier than today).";
                        }
                        return undefined;
                    }
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon6 = accidentalDetailsConfig.LocationOfAccident) !== null && _accidentalDetailsCon6 !== void 0 && _accidentalDetailsCon6.show ? {
                    type: FormItemTypes.TextInput,
                    name: 'AccidentLocation',
                    label: 'Location of Accident',
                    placeholder: 'Enter accident location',
                    disabled: isDisabled,
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon7 = accidentalDetailsConfig.LocationOfAccident) === null || _accidentalDetailsCon7 === void 0 ? void 0 : _accidentalDetailsCon7.IsMandatory,
                    validator: function (value) {
                        if ((value === null || value === void 0 ? void 0 : value.length) > 100) {
                            return "Please enter a valid location (max 100 characters).";
                        }
                        return undefined;
                    }
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon8 = accidentalDetailsConfig.NatureOfAccident) !== null && _accidentalDetailsCon8 !== void 0 && _accidentalDetailsCon8.show ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'NatureOfAccidentId',
                    label: 'Nature of Accident',
                    displayExpr: 'Name',
                    placeholder: 'Select nature of accident',
                    getListData: getNatureOfAccidentList,
                    apiKey: JobCardKeys.NatureOfAccidentList,
                    disabled: isDisabled,
                    valueExpr: 'id',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon9 = accidentalDetailsConfig.NatureOfAccident) === null || _accidentalDetailsCon9 === void 0 ? void 0 : _accidentalDetailsCon9.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon10 = accidentalDetailsConfig.AccidentReportNumber) !== null && _accidentalDetailsCon10 !== void 0 && _accidentalDetailsCon10.show ? {
                    type: FormItemTypes.TextInput,
                    name: 'AccidentReportNumber',
                    label: 'Accident Report No.',
                    placeholder: 'Enter accident report no.',
                    disabled: isDisabled,
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon11 = accidentalDetailsConfig.AccidentReportNumber) === null || _accidentalDetailsCon11 === void 0 ? void 0 : _accidentalDetailsCon11.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon12 = accidentalDetailsConfig.DriverName) !== null && _accidentalDetailsCon12 !== void 0 && _accidentalDetailsCon12.show ? {
                    type: FormItemTypes.TextInput,
                    name: 'DriverName',
                    disabled: isDisabled,
                    label: 'Driver Name',
                    placeholder: 'Enter driver name',
                    maxLength: 100,
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon13 = accidentalDetailsConfig.DriverName) === null || _accidentalDetailsCon13 === void 0 ? void 0 : _accidentalDetailsCon13.IsMandatory
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    display: 'flex',
                    name: '',
                    columnSize: 12,
                    elements: [accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon14 = accidentalDetailsConfig.DamageDescription) !== null && _accidentalDetailsCon14 !== void 0 && _accidentalDetailsCon14.show ? {
                            type: FormItemTypes.TextInput,
                            name: 'DamageDescription',
                            label: 'Damage Description',
                            placeholder: 'Enter a description...',
                            disabled: isDisabled,
                            multiline: true,
                            rows: 6,
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon15 = accidentalDetailsConfig.DamageDescription) === null || _accidentalDetailsCon15 === void 0 ? void 0 : _accidentalDetailsCon15.IsMandatory,
                            validator: function (value) {
                                // Prevent selecting a future date/time
                                if ((value === null || value === void 0 ? void 0 : value.length) > 100) {
                                    return "Please enter a valid description (max 100 characters).";
                                }
                                return undefined;
                            }
                        } : null, {
                            type: FormItemTypes.CardComponent,
                            name: 'AttachmentsCard',
                            hidden: (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon16 = accidentalDetailsConfig.Attachments) === null || _accidentalDetailsCon16 === void 0 ? void 0 : _accidentalDetailsCon16.show) === false,
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            sx: {
                                p: {
                                    xs: 0,
                                    sm: 0
                                },
                                border: 0
                            },
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: 'accidentalDetailsAttachments',
                                    label: 'Accidental details attachments',
                                    columnSize: 12,
                                    hidden: (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon17 = accidentalDetailsConfig.Attachments) === null || _accidentalDetailsCon17 === void 0 ? void 0 : _accidentalDetailsCon17.show) === false,
                                    validator: function (value, state) {
                                        var _state$accidentalDeta, _accidentalDetailsCon18;
                                        if ((state === null || state === void 0 || (_state$accidentalDeta = state.accidentalDetailsAttachments) === null || _state$accidentalDeta === void 0 ? void 0 : _state$accidentalDeta.length) === 0 && accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon18 = accidentalDetailsConfig.Attachments) !== null && _accidentalDetailsCon18 !== void 0 && _accidentalDetailsCon18.IsMandatory) {
                                            return 'This field is required';
                                        }
                                        return '';
                                    },
                                    element: function (props) {
                                        var _accidentalDetailsCon19, _accidentalDetailsPho;
                                        return /*#__PURE__*/ React.createElement(MuiStack, {
                                            spacing: 0,
                                            direction: 'column'
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            sx: {
                                                "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon19 = accidentalDetailsConfig.Attachments) !== null && _accidentalDetailsCon19 !== void 0 && _accidentalDetailsCon19.IsMandatory ? {
                                                    content: '"*"',
                                                    color: "red",
                                                    marginLeft: "2px"
                                                } : {}
                                            },
                                            variant: "h6",
                                            color: systemColor.lightGrey,
                                            paddingY: 1
                                        }, t("Attachments")), /*#__PURE__*/ React.createElement(MuiStack, {
                                            spacing: 1
                                        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
                                            disabled: isDisabled,
                                            onClick: function () {
                                                setOpenUpload(true);
                                            },
                                            sx: {
                                                height: '72px',
                                                width: '72px',
                                                outline: '1px dashed',
                                                outlineColor: 'secondary.200',
                                                borderRadius: '8px',
                                                bgcolor: '#FFFFFF',
                                                color: 'text.secondary',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                ml: '1px'
                                            }
                                            // disabled:isDisabled,
                                            ,
                                            name: "Upload",
                                            startIcon: '+'
                                        })), /*#__PURE__*/ React.createElement(MuiStack, {
                                            spacing: 1,
                                            display: 'flex',
                                            alignItems: "center"
                                        }, accidentalDetailsPhotographList === null || accidentalDetailsPhotographList === void 0 || (_accidentalDetailsPho = accidentalDetailsPhotographList.slice(0, 3)) === null || _accidentalDetailsPho === void 0 ? void 0 : _accidentalDetailsPho.map(function (item, photoIndex) { /*#__PURE__*/ return React.createElement(MuiStack, {
                                            key: photoIndex
                                        }, /*#__PURE__*/ React.createElement("div", {
                                            className: "1st",
                                            style: {
                                                position: 'relative',
                                                display: 'inline-block'
                                            }
                                        }, !isDisabled && /*#__PURE__*/ React.createElement(GridCloseIcon, {
                                            onClick: function () { return onClickRemovePhotoIcon(photoIndex, item.AttachmentId, item.ParentId); },
                                            sx: {
                                                position: 'absolute',
                                                zIndex: 1,
                                                right: 4,
                                                top: 4,
                                                backgroundColor: "white",
                                                height: '15px',
                                                width: '15px',
                                                borderRadius: 50
                                            }
                                        }), /*#__PURE__*/ React.createElement("img", {
                                            src: item === null || item === void 0 ? void 0 : item.blobUrl,
                                            id: "downloadCustomerImg" + photoIndex,
                                            alt: "Image ".concat(photoIndex + 1),
                                            style: {
                                                width: '72px',
                                                height: '72px',
                                                borderRadius: '8px',
                                                position: 'relative'
                                            },
                                            onClick: function () { return handleClickImage(item === null || item === void 0 ? void 0 : item.blobUrl); }
                                        }), accidentalDetailsPhotographList.length > 3 && photoIndex === 2 && /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "body2",
                                            sx: {
                                                position: 'absolute',
                                                top: '20px',
                                                left: '20%',
                                                color: 'primary',
                                                cursor: 'pointer'
                                            },
                                            onClick: function () { return handleViewAllClick(item); }
                                        }, t("View All")))); }))));
                                    }
                                }, accidentalDetailsAudioList.length > 0 ? {
                                    type: FormItemTypes.Box,
                                    name: 'Audio',
                                    label: '',
                                    value: null,
                                    columnSize: 12,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: 'AudioPlayer',
                                            label: '',
                                            value: null,
                                            columnSize: 12,
                                            element: function () {
                                                return /*#__PURE__*/ React.createElement(MuiStack, {
                                                    width: '100%',
                                                    sx: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '72px',
                                                        paddingLeft: !IS_MOBILE ? '16px' : '0px'
                                                    }
                                                }, /*#__PURE__*/ React.createElement(MuiStack, {
                                                    width: '100%',
                                                    bgcolor: '#F4F7FA',
                                                    style: {
                                                        border: '1px solid #DEE4EB',
                                                        borderRadius: "8px",
                                                        padding: '5px 16px  5px 5px',
                                                        alignItems: 'center',
                                                        alignSelf: 'center'
                                                    }
                                                }, /*#__PURE__*/ React.createElement(AudioPlayer, {
                                                    src: accidentalDetailsAudioList.length > 0 ? accidentalDetailsAudioList[0].blobUrl : "",
                                                    isSlider: true,
                                                    audioDuration: accidentalDetailsAudioList.length > 0 ? accidentalDetailsAudioList[0].audioDuration : 0
                                                })), !isDisabled && /*#__PURE__*/ React.createElement("img", {
                                                    src: DeleteButtonNewIcon,
                                                    alt: "gallery-disable",
                                                    style: {
                                                        width: '36px',
                                                        height: '36px',
                                                        marginLeft: '10px',
                                                        cursor: 'pointer'
                                                    },
                                                    onClick: onDeleteRecording
                                                }));
                                            }
                                        }]
                                } : null, {
                                    type: FormItemTypes.IconButton,
                                    disabled: isDisabled,
                                    onClick: function () {
                                        setAudioCaptureClick(function (pre) { return !pre; });
                                    },
                                    name: 'record',
                                    children: /*#__PURE__*/ React.createElement(AudioButtonIcon, {
                                        sx: {
                                            stroke: systemColor.primary
                                        }
                                    }),
                                    sx: {
                                        opacity: isDisabled ? 0.5 : 'unset',
                                        display: accidentalDetailsAudioList.length === 0 ? 'block' : 'none'
                                    }
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: '',
                                    columnSize: 12,
                                    element: function (props) {
                                        var _props$error;
                                        var error = props === null || props === void 0 || (_props$error = props.error) === null || _props$error === void 0 ? void 0 : _props$error.accidentalDetailsAttachments;
                                        return error && /*#__PURE__*/ React.createElement(Typography, {
                                            color: systemColor.error,
                                            variant: "caption",
                                            sx: {
                                                mt: 1
                                            }
                                        }, error);
                                    }
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Insurance & policy details',
            name: 'InsuranceAndPolicy details',
            hidden: !accidentalDetailsConfig || ((_Object$keys2 = Object.keys(accidentalDetailsConfig)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) === 0 || insuranceDetailsFields.every(function (field) {
                var _accidentalDetailsCon20;
                return (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon20 = accidentalDetailsConfig[field]) === null || _accidentalDetailsCon20 === void 0 ? void 0 : _accidentalDetailsCon20.show) === false;
            }),
            value: null,
            columnSize: 12,
            elements: [accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon21 = accidentalDetailsConfig.InsuranceProviderName) !== null && _accidentalDetailsCon21 !== void 0 && _accidentalDetailsCon21.show ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'InsuranceProviderId',
                    disabled: isDisabled,
                    label: 'Insurance provider',
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.LegalName, " ").concat(option !== null && option !== void 0 && option.BranchCode ? "(".concat(option === null || option === void 0 ? void 0 : option.BranchCode, ")") : ''); },
                    placeholder: 'Select insurance provider',
                    getListData: getInsuranceProviderList,
                    apiKey: JobCardKeys.InsuranceProviderList,
                    valueExpr: 'id',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon22 = accidentalDetailsConfig.InsuranceProviderName) === null || _accidentalDetailsCon22 === void 0 ? void 0 : _accidentalDetailsCon22.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon23 = accidentalDetailsConfig.PolicyNumber) !== null && _accidentalDetailsCon23 !== void 0 && _accidentalDetailsCon23.show ? {
                    type: FormItemTypes.TextInput,
                    disabled: isDisabled,
                    name: 'PolicyNumber',
                    label: 'Policy Number',
                    placeholder: 'Enter policy no.',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon24 = accidentalDetailsConfig.PolicyNumber) === null || _accidentalDetailsCon24 === void 0 ? void 0 : _accidentalDetailsCon24.IsMandatory,
                    validator: function (value) {
                        // Prevent selecting a future date/time
                        if ((value === null || value === void 0 ? void 0 : value.length) > PolicyNumberMaxLength) {
                            return "Please enter a valid insurance policy number (max ".concat(PolicyNumberMaxLength, " characters).");
                        }
                        return undefined;
                    }
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon25 = accidentalDetailsConfig.PolicyHolderName) !== null && _accidentalDetailsCon25 !== void 0 && _accidentalDetailsCon25.show ? {
                    type: FormItemTypes.TextInput,
                    name: 'PolicyHolderName',
                    disabled: isDisabled,
                    label: 'Policy Holder Name',
                    placeholder: 'Enter policy holder name',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon26 = accidentalDetailsConfig.PolicyHolderName) === null || _accidentalDetailsCon26 === void 0 ? void 0 : _accidentalDetailsCon26.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon27 = accidentalDetailsConfig.InsurancePolicyExpiryDate) !== null && _accidentalDetailsCon27 !== void 0 && _accidentalDetailsCon27.show ? {
                    type: FormItemTypes.DatePicker,
                    name: 'PolicyExpiryDate',
                    disabled: isDisabled,
                    label: 'Policy expiry date',
                    placeholder: 'Select policy expiry date',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon28 = accidentalDetailsConfig.InsurancePolicyExpiryDate) === null || _accidentalDetailsCon28 === void 0 ? void 0 : _accidentalDetailsCon28.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon29 = accidentalDetailsConfig.InsuredName) !== null && _accidentalDetailsCon29 !== void 0 && _accidentalDetailsCon29.show ? {
                    type: FormItemTypes.TextInput,
                    disabled: isDisabled,
                    name: 'InsuredName',
                    label: 'Insured Name',
                    placeholder: 'Enter insured name',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon30 = accidentalDetailsConfig.InsuredName) === null || _accidentalDetailsCon30 === void 0 ? void 0 : _accidentalDetailsCon30.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon31 = accidentalDetailsConfig.CoverageType) !== null && _accidentalDetailsCon31 !== void 0 && _accidentalDetailsCon31.show ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'CoverageTypeId',
                    disabled: isDisabled,
                    label: 'Coverage Type',
                    displayExpr: 'CoverageTypeName',
                    placeholder: 'Select coverage type',
                    getListData: getCoverageTypeList,
                    apiKey: JobCardKeys.CoverageTypeList,
                    valueExpr: 'CoverageTypeId',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon32 = accidentalDetailsConfig.CoverageType) === null || _accidentalDetailsCon32 === void 0 ? void 0 : _accidentalDetailsCon32.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon33 = accidentalDetailsConfig.LossType) !== null && _accidentalDetailsCon33 !== void 0 && _accidentalDetailsCon33.show ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'LossTypeId',
                    disabled: isDisabled,
                    label: 'Loss Type',
                    displayExpr: 'DisplayName',
                    placeholder: 'Select loss type',
                    getListData: getLossTypeList,
                    apiKey: JobCardKeys.LossTypeList,
                    valueExpr: 'id',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon34 = accidentalDetailsConfig.LossType) === null || _accidentalDetailsCon34 === void 0 ? void 0 : _accidentalDetailsCon34.IsMandatory
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon35 = accidentalDetailsConfig.SurveyorName) !== null && _accidentalDetailsCon35 !== void 0 && _accidentalDetailsCon35.show ? {
                    type: FormItemTypes.TextInput,
                    name: 'IntimatorName',
                    label: 'Surveyor Name',
                    disabled: isDisabled,
                    placeholder: 'Enter surveyor name',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon36 = accidentalDetailsConfig.SurveyorName) === null || _accidentalDetailsCon36 === void 0 ? void 0 : _accidentalDetailsCon36.IsMandatory,
                    validator: function (value, state) {
                        if (!value) {
                            return undefined;
                        }
                        var regex = /^[A-Za-z.\-\s]{2,100}$/;
                        var isValid = regex.test(value);
                        if (!isValid) {
                            return "Please enter a valid surveyor name (only letters, hyphens, periods, 2-100 characters).";
                        }
                        return undefined;
                    }
                } : null, accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon37 = accidentalDetailsConfig.SurveyorNumber) !== null && _accidentalDetailsCon37 !== void 0 && _accidentalDetailsCon37.show ? {
                    type: FormItemTypes.NumberInput,
                    name: 'IntimatorNumber',
                    disabled: isDisabled,
                    label: 'Surveyor Mobile Number',
                    placeholder: 'Enter surveyor mobile number',
                    required: accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon38 = accidentalDetailsConfig.SurveyorNumber) === null || _accidentalDetailsCon38 === void 0 ? void 0 : _accidentalDetailsCon38.IsMandatory,
                    validator: function (value, state) {
                        if (!value) {
                            return undefined;
                        }
                        var isValid = /^[6-9]\d{9}$/.test(value);
                        if (!isValid) {
                            return "Please enter a valid 10-digit mobile number starting with 6/7/8/9.";
                        }
                        return undefined;
                    }
                } : null]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Campaign details',
            name: '',
            value: null,
            xs: 12,
            sm: 12,
            md: 6,
            lg: 6,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'CampaignId',
                    label: 'Campaign',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    getListData: getCampaignList,
                    disabled: isDisabled,
                    getOptionLabel: function (option) {
                        var _option$Name, _option$Code;
                        return "".concat((_option$Name = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name !== void 0 ? _option$Name : '-', " (").concat((_option$Code = option === null || option === void 0 ? void 0 : option.Code) !== null && _option$Code !== void 0 ? _option$Code : '-', ")");
                    },
                    apiKey: 'campaignList',
                    renderOption: function (props, option) {
                        var _option$Name2, _option$Code2;
                        var fromDate = option !== null && option !== void 0 && option.DateEffectiveFrom ? dayjs(option.DateEffectiveFrom).format('DD MMM, YYYY') : '-';
                        var toDate = option !== null && option !== void 0 && option.DateEffectiveTo ? dayjs(option.DateEffectiveTo).format('DD MMM, YYYY') : '-';
                        var date = fromDate && toDate ? "".concat(fromDate, " - ").concat(toDate) : fromDate || toDate || '';
                        return /*#__PURE__*/ React.createElement(Box, _extends({
                            component: "li"
                        }, props, {
                            sx: {
                                p: 2
                            }
                        }), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
                            fontSize: '14px'
                        }, "".concat((_option$Name2 = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name2 !== void 0 ? _option$Name2 : '-', " (").concat((_option$Code2 = option === null || option === void 0 ? void 0 : option.Code) !== null && _option$Code2 !== void 0 ? _option$Code2 : '-', ")")), /*#__PURE__*/ React.createElement(Typography, {
                            fontSize: '12px',
                            color: "text.secondary"
                        }, date)));
                    },
                    apiRequest: {
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ModuleEntityId: null
                    },
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    placeholder: 'Select campaign'
                }
                // only UAT v2.5
                // {
                //     type: FormItemTypes.TextInput,
                //     name: 'Coupon code',
                //     disabled: isDisabled,
                //     label: 'Coupon code',
                //     xs: 12,
                //     sm: 6,
                //     md: 6,
                //     lg: 6,
                // },
            ]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'UCN details',
            name: '',
            value: null,
            disabled: isDisabled,
            xs: 12,
            sm: 12,
            md: 6,
            lg: 6,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "UCN",
                    id: 'UCN-input',
                    label: "UCN",
                    placeholder: 'Please enter UCN',
                    value: ucnCode,
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    disabled: isDisabled || isUcnFieldDisabled() || ucnState === 'Send' || ucnState === 'Check UCN',
                    onChange: function (event, value) {
                        setUcnState('Apply');
                        setUcnCode(value ? value.trim() : "");
                        setUcnHelperText(UCN_HELPER_TEXT_STATE.INFO);
                    },
                    valueGetter: function (formValues, field) {
                        return ucnCode;
                    },
                    InputProps: {
                        endAdornment: /*#__PURE__*/ React.createElement(React.Fragment, null, ucnState === 'Resend' && IsSendUCNDisabled ? /*#__PURE__*/ React.createElement(React.Fragment, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
                            sx: {
                                height: "100%"
                            },
                            orientation: "vertical"
                        }), /*#__PURE__*/ React.createElement(InputAdornment, {
                            position: "end"
                        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
                            variant: "text"
                            // loading={loader.isLoaderOpen}
                            ,
                            style: {
                                backgroundColor: "transparent"
                            },
                            onClick: handleUcnButtonSubmit,
                            name: t(ucnState),
                            disabled: isUcnButtonDisbaled()
                        }))))
                    },
                    helperText: getUcnHelperText()
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Customer Complaints',
            name: '',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Accordian,
                    name: 'customer',
                    columnSize: 12,
                    value: null,
                    defaultExpanded: true,
                    summaryProps: {
                        sx: {
                            flexDirection: 'row-reverse'
                        }
                    },
                    // summary for only UAT v2.5
                    summary: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            gap: '20px',
                            columnSize: 12,
                            alignItems: 'center',
                            pl: 0.5,
                            elements: [{
                                    type: FormItemTypes.Icon,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(FileIcon, null),
                                    color: 'info',
                                    columnSize: 0,
                                    sx: {
                                        width: 12,
                                        height: 12
                                    },
                                    containerProps: {
                                        sx: {
                                            height: 20,
                                            width: 20,
                                            bgcolor: 'info.100',
                                            borderRadius: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    columnSize: true,
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            gap: '4px',
                                            columnSize: 0,
                                            sx: {
                                                flexDirection: {
                                                    xs: 'column',
                                                    sm: 'row'
                                                },
                                                alignItems: {
                                                    xs: 'flex-start',
                                                    sm: 'center'
                                                }
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: 'Taken by',
                                                    columnSize: 0,
                                                    sx: {
                                                        textWrap: 'nowrap'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'customer-voice-taken-sa',
                                                    // value: CustomerVoiceData?.GivenName + ' ' + CustomerVoiceData?.FamilyName,
                                                    fontWeight: 'strong',
                                                    columnSize: 0,
                                                    sx: {
                                                        textWrap: 'wrap'
                                                    },
                                                    valueGetter: function () {
                                                        var given = (CustomerVoiceData === null || CustomerVoiceData === void 0 ? void 0 : CustomerVoiceData.GivenName) || '-';
                                                        var family = (CustomerVoiceData === null || CustomerVoiceData === void 0 ? void 0 : CustomerVoiceData.FamilyName) || '-';
                                                        return "".concat(given, " ").concat(family).trim();
                                                    }
                                                }]
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'customer-voice-date',
                                            fontWeight: 'normal',
                                            fontSize: 'sm',
                                            color: 'text.secondary',
                                            columnSize: 0,
                                            valueGetter: function () {
                                                return dayjs(CustomerVoiceData === null || CustomerVoiceData === void 0 ? void 0 : CustomerVoiceData.RecordedDateTime).format('DD MMM, YYYY , hh:mm a');
                                            }
                                        }]
                                }, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    gap: '16px',
                                    columnSize: 0,
                                    elements: [{
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(Clapperboard, null),
                                            color: 'info',
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(VolumeMax, null),
                                            color: 'info',
                                            columnSize: 0
                                        }]
                                }]
                        }],
                    detailPanelProps: {
                        px: 2.5,
                        pb: 2.5
                    },
                    elements: __spreadArray([{
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'CustomerComplaint',
                            label: 'Customer Voice :',
                            value: CustomerVoiceData === null || CustomerVoiceData === void 0 ? void 0 : CustomerVoiceData.CustomerComplaint,
                            multiline: true,
                            minRows: IS_TABLET ? 8 : 4,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            disabled: true,
                            FormHelperTextProps: {
                                sx: {
                                    textAlign: 'right'
                                }
                            },
                            setFieldProps: function (formValues, currValue, field, formApi) {
                                var currentLength = currValue ? currValue.length : 0;
                                return {
                                    helperText: "".concat(currentLength, "/1000")
                                };
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            spacing: 0,
                            xs: 12,
                            sm: 6,
                            md: (customerComplaintAudiosList === null || customerComplaintAudiosList === void 0 ? void 0 : customerComplaintAudiosList.length) > 0 ? 9 : 8,
                            hidden: !(customerComplaintImagesList !== null && customerComplaintImagesList !== void 0 && customerComplaintImagesList.length),
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Media : ',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: 'secondary',
                                    labelTypographyProps: {
                                        display: 'none'
                                    },
                                    mb: 0.5
                                }, {
                                    type: FormItemTypes.CardComponent,
                                    name: 'CustomerComplaint',
                                    label: '',
                                    value: null,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    sx: {
                                        bgcolor: 'secondary.50',
                                        border: 'none',
                                        padding: '0px'
                                    },
                                    elements: [
                                        // {
                                        // type: FormItemTypes.Button,
                                        // name: '',
                                        // columnSize: 0,
                                        // sx: {
                                        //     height: '72px',
                                        //     width: '77px',
                                        //     border: '1px dashed #DEE4EB',
                                        //     borderRadius: '8px',
                                        //     bgcolor: '#FFFFFF',
                                        //     padding: '8px',
                                        //     gap: '4px',
                                        //     color: '#6A7682',
                                        //     display: 'flex',
                                        //     flexDirection: 'column',
                                        //     mr: 2,
                                        // },
                                        // children: 'Upload',
                                        // onClick: () => { setOpenUpload(true) },
                                        // startIcon: <img style={{ paddingLeft: '5px' }} src={PlusGrayIconNew} alt="" loading="lazy" />,
                                        // setFormState: async (state) => {
                                        //     const res = await dispatch(showSurface({
                                        //         type: 'Dialog',
                                        //         Component: ImageUploadModal,
                                        //         containerProps: {
                                        //             anchor: "bottom",
                                        //             PaperProps: {
                                        //                 sx: {
                                        //                     borderRadius: '8px 8px 0 0'
                                        //                 }
                                        //             }
                                        //         },
                                        //         componentProps: { data: state?.CustomerComplaints } as IViewJobItemsProps
                                        //     }));
                                        //     if (res?.payload) {
                                        //         return {
                                        //             CustomerComplaints: res?.payload
                                        //         }
                                        //     }
                                        // }
                                        // },
                                        // {
                                        //   type: FormItemTypes.Avatar,
                                        //   name: '',
                                        //   variant:'rounded',
                                        //   sx:{height:'72px', width:'77px'},
                                        //   columnSize:0 ,
                                        // },
                                        // {
                                        //     type: FormItemTypes.Custom,
                                        //     name: 'Upload',
                                        //     label: '',
                                        //     value: null,
                                        //     columnSize: 0,
                                        //     element: () => {
                                        //         return (
                                        //             <MuiStack gap={2}>
                                        //                 {list?.imageAttachementURLs?.length > 0 ?
                                        //                     list?.imageAttachementURLs?.map((img: any, idx: number) => (
                                        //                         <Avatar src={img} variant="rounded" sx={{ height: '72px', width: "72px" }} />
                                        //                     )) :
                                        //                     <Avatar variant="rounded" sx={{ height: '72px', width: "72px" }} />
                                        //                 }
                                        //             </MuiStack>
                                        //         )
                                        //     }
                                        // },
                                        {
                                            type: FormItemTypes.Custom,
                                            name: 'Upload',
                                            label: '',
                                            value: null,
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            columnSize: 12,
                                            element: function () {
                                                var _customerComplaintAud;
                                                return /*#__PURE__*/ React.createElement(MuiStack, {
                                                    sx: {
                                                        flexDirection: IS_MOBILE || IS_TABLET ? 'column' : 'row',
                                                        width: IS_MOBILE || IS_TABLET ? '100%' : '100%'
                                                    }
                                                }, (customerComplaintAudiosList === null || customerComplaintAudiosList === void 0 ? void 0 : customerComplaintAudiosList.length) > 0 && /*#__PURE__*/ React.createElement(MuiStack, {
                                                    sx: {
                                                        width: IS_MOBILE || IS_TABLET ? '100%' : '40%'
                                                    },
                                                    alignItems: 'center',
                                                    marginRight: 1
                                                }, /*#__PURE__*/ React.createElement(AudioPlayer, {
                                                    src: (_customerComplaintAud = customerComplaintAudiosList[0]) === null || _customerComplaintAud === void 0 ? void 0 : _customerComplaintAud.base64,
                                                    isSlider: true,
                                                    audioBgColor: '#FFFFFF'
                                                })), /*#__PURE__*/ React.createElement(MuiStack, {
                                                    overflow: 'scroll',
                                                    columnGap: 1.5,
                                                    marginTop: IS_MOBILE || IS_TABLET ? 1.5 : 0,
                                                    justifyContent: IS_MOBILE || IS_TABLET ? 'flex-start' : 'space-between',
                                                    display: 'flex',
                                                    alignItems: "center"
                                                }, customerComplaintImagesList === null || customerComplaintImagesList === void 0 ? void 0 : customerComplaintImagesList.map(function (img, idx) {
                                                    /*#__PURE__*/
                                                    // <Grid xs={4} sm={1.5} md={2} lg={1.5}>
                                                    return React.createElement(MuiStack, {
                                                        justifyContent: "space-between"
                                                    }, /*#__PURE__*/ React.createElement("div", {
                                                        style: {
                                                            position: 'relative'
                                                        }
                                                    }, /*#__PURE__*/ React.createElement("img", {
                                                        src: img.base64,
                                                        id: "downloadCustomerImg" + idx,
                                                        alt: "Image ".concat(idx + 1),
                                                        style: {
                                                            width: '70px',
                                                            height: '70px',
                                                            borderRadius: '8px',
                                                            position: 'relative'
                                                        },
                                                        onClick: function () { return handleClickImage(img.base64); }
                                                    })));
                                                }
                                                // </Grid>
                                                )));
                                            }
                                        }
                                    ]
                                }]
                        }], (IS_MOBILE ? [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'end',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: 'job-items',
                                    children: 'Job items',
                                    columnSize: 0,
                                    setFormState: function (state) { return __awaiter(void 0, void 0, void 0, function () {
                                        var res;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Drawer',
                                                        Component: ViewJobItems,
                                                        containerProps: {
                                                            anchor: "bottom",
                                                            PaperProps: {
                                                                sx: {
                                                                    borderRadius: '8px 8px 0 0'
                                                                }
                                                            }
                                                        },
                                                        componentProps: {
                                                            data: state === null || state === void 0 ? void 0 : state.CustomerComplaints
                                                        }
                                                    }))];
                                                case 1:
                                                    res = _a.sent();
                                                    if (res !== null && res !== void 0 && res.payload) {
                                                        return [2 /*return*/, {
                                                                CustomerComplaints: res === null || res === void 0 ? void 0 : res.payload
                                                            }];
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        }] : [{
                            type: FormItemTypes.Custom,
                            name: "CustomerComplaints",
                            disabled: isDisabled,
                            element: CustomerComplaintEditableDataGrid,
                            columnSize: 12
                        }]), true)
                }]
        }];
    var partandlabourField = [isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'part',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    paddingY: 0,
                    paddingX: 0.5,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'partDetail',
                            label: '',
                            value: null,
                            children: 'Parts',
                            columnSize: 0,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$partDetai2;
                                var selectedParts = formValues === null || formValues === void 0 || (_formValues$partDetai2 = formValues.partDetails) === null || _formValues$partDetai2 === void 0 ? void 0 : _formValues$partDetai2.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                                return (selectedParts === null || selectedParts === void 0 ? void 0 : selectedParts.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$partDetai3, _selectedParts$length;
                                var selectedParts = formValues === null || formValues === void 0 || (_formValues$partDetai3 = formValues.partDetails) === null || _formValues$partDetai3 === void 0 ? void 0 : _formValues$partDetai3.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_selectedParts$length = selectedParts === null || selectedParts === void 0 ? void 0 : selectedParts.length) !== null && _selectedParts$length !== void 0 ? _selectedParts$length : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }]
                }],
            elements: [
                // only UAT v2.5
                // {
                //     type: FormItemTypes.SearchSelect,
                //     name: 'AddParts',
                //     getListData: getPartList,
                //     apiKey: 'partList',
                //     multiple: true,
                //     renderTags: () => null,
                //     clearText: 'Clear Selected Parts',
                //     columnSize: true,
                //     placeholder: 'Enter part name code',
                //     displayExpr: 'Name',
                //     valueExpr: 'id',
                //     setFormState: (state, value) => {
                //         if (!value?.length) return {};
                //         return {
                //             partDetails: [
                //                 ...value.slice(0, -1),
                //                 {
                //                     ChildName: value.at(-1)?.Name,
                //                     ChildId: value.at(-1)?.id,
                //                     id: value.at(-1)?.id,
                //                     ChildCode: value.at(-1)?.SkuCode,
                //                     UnitOfMeasurementId: value.at(-1)?.UnitOfMeasurementId,
                //                     UnitOfMeasurementName: value.at(-1)?.UnitOfMeasurementName,
                //                     Quantity: value.at(-1)?.Quantity
                //                 }
                //             ]
                //         };
                //     },
                //     valueGetter: (state) => state.partDetails,
                //     hidden: isFI,
                // },
                // {
                //     type: FormItemTypes.Button,
                //     name: 'MoreActionsPart',
                //     children: <MoreVert />,
                //     size: 'icon',
                //     variant: 'outlined',
                //     color: 'secondary',
                //     columnSize: 0,
                //     setFormState: async (state, e) => {
                //         const action = await dispatch(showSurface({
                //             type: 'Menu',
                //             containerProps: {
                //                 anchorEl: e.target.parentElement,
                //                 transformOrigin: {
                //                     vertical: 'top',
                //                     horizontal: 'right'
                //                 },
                //                 anchorOrigin: {
                //                     vertical: 'bottom',
                //                     horizontal: 'right'
                //                 },
                //                 disableScrollLock: true
                //             },
                //             Component: ActionMenuList,
                //             componentProps: {
                //                 items: [
                //                     {
                //                         id: 'delete',
                //                         disabled: isDisabled,
                //                         children: [<Delete color='secondary' fontSize="small" />, "Delete"]
                //                     }
                //                 ]
                //             } as Partial<ActionMenuListProps>
                //         }));
                //         if (action?.payload === 'delete') {
                //             let updatedPartList = state.partDetails?.map((item: any) => {
                //                 if (item.Selected) {
                //                     return {
                //                         ...item,
                //                         "UserDeleted": item.Selected,
                //                         "IsActive": false,
                //                         "IsDeleted": true,
                //                     }
                //                 } else {
                //                     return {
                //                         ...item,
                //                         "UserDeleted": false,
                //                     }
                //                 }
                //             })
                //             const req = {
                //                 "SystemName": "Products",
                //                 "Products": updatedPartList
                //             }
                //             const validateResponse = await validateDeletePartLabour({ request: req })
                //             if (validateResponse.success && validateResponse.statusCode === 200) {
                //                 return { partDetails: updatedPartList }
                //             }
                //         }
                //     },
                //     hidden: isFI,
                // },
                // select all parts and delete parts added only UAT v2.5
                {
                    type: FormItemTypes.CheckBox,
                    name: 'SelectAllParts',
                    label: '',
                    columnSize: 0,
                    setFormState: function (state, checked) {
                        var _state$partDetails;
                        return {
                            partDetails: state === null || state === void 0 || (_state$partDetails = state.partDetails) === null || _state$partDetails === void 0 ? void 0 : _state$partDetails.map(function (p) { return _objectSpread(_objectSpread({}, p), {}, {
                                Selected: checked
                            }); })
                        };
                    },
                    formControlLabelProps: {
                        sx: {
                            m: 0
                        }
                    },
                    sx: {
                        bgcolor: 'white',
                        borderRadius: 2,
                        outline: '1px solid',
                        outlineColor: 'secondary.200',
                        outlineOffset: -1,
                        p: 1
                    },
                    hidden: isDisabled || isFI
                }, {
                    type: FormItemTypes.Button,
                    name: 'delete-partDetails',
                    children: /*#__PURE__*/ React.createElement(Delete, null),
                    size: 'icon',
                    variant: 'outlined',
                    color: 'secondary',
                    disabled: true,
                    columnSize: 0,
                    setFieldProps: function (state) {
                        var _state$partDetails2;
                        return {
                            disabled: !(state !== null && state !== void 0 && (_state$partDetails2 = state.partDetails) !== null && _state$partDetails2 !== void 0 && _state$partDetails2.some(function (item) { return item === null || item === void 0 ? void 0 : item.Selected; }))
                        };
                    },
                    setFormState: function (state) { return __awaiter(void 0, void 0, void 0, function () {
                        var _state$partDetails3, updatedPartList, req, validateResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    updatedPartList = (_state$partDetails3 = state.partDetails) === null || _state$partDetails3 === void 0 ? void 0 : _state$partDetails3.map(function (item) {
                                        if (item.Selected) {
                                            return _objectSpread(_objectSpread({}, item), {}, {
                                                "UserDeleted": item.Selected,
                                                "IsActive": false,
                                                "IsDeleted": true
                                            });
                                        }
                                        else {
                                            return _objectSpread(_objectSpread({}, item), {}, {
                                                "UserDeleted": false
                                            });
                                        }
                                    });
                                    if (!(updatedPartList !== null && updatedPartList !== void 0 && updatedPartList.length))
                                        return [2 /*return*/];
                                    req = {
                                        "SystemName": "Products",
                                        "Products": updatedPartList
                                    };
                                    return [4 /*yield*/, validateDeletePartLabour({
                                            request: req
                                        })];
                                case 1:
                                    validateResponse = _a.sent();
                                    if (validateResponse.success && validateResponse.statusCode === 200) {
                                        return [2 /*return*/, {
                                                partDetails: updatedPartList,
                                                SelectAllParts: false
                                            }];
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    hidden: isDisabled || isFI
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12,
                    hidden: isDisabled || isFI
                }, {
                    type: FormItemTypes.List,
                    name: 'partDetails',
                    columnSize: 12,
                    disabled: isDisabled || isFI,
                    value: null,
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    getRowHeight: function () { return 'auto'; },
                    disableCheckboxSelection: isDisabled || isFI,
                    // apiKey: JobCardKeys.Parts,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (_ref3) {
                                var row = _ref3.row;
                                return /*#__PURE__*/ React.createElement(Stack, {
                                    py: '12px'
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    id: "part-name",
                                    fontWeight: "medium",
                                    sx: {
                                        textWrap: 'pretty'
                                    }
                                }, row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    id: "part-code",
                                    fontSize: "sm",
                                    color: "secondary"
                                }, row.ChildCode ? '#' + row.ChildCode : ''));
                            }
                        }],
                    elements: partElements,
                    valueGetter: function (formValues) {
                        var _formValues$partDetai4;
                        return (formValues === null || formValues === void 0 || (_formValues$partDetai4 = formValues.partDetails) === null || _formValues$partDetai4 === void 0 ? void 0 : _formValues$partDetai4.filter(function (item) { return !item.IsDeleted; })) || [];
                    },
                    sx: {
                        bgcolor: 'white'
                    },
                    validator: function (value, state) {
                        var findError = value === null || value === void 0 ? void 0 : value.find(function (item) { return item.error && item.error.message; });
                        if (findError) {
                            var _findError$error, _findError$error2;
                            return {
                                field: findError === null || findError === void 0 || (_findError$error = findError.error) === null || _findError$error === void 0 ? void 0 : _findError$error.field,
                                rowId: findError === null || findError === void 0 ? void 0 : findError.id,
                                id: nanoid(4),
                                message: findError === null || findError === void 0 || (_findError$error2 = findError.error) === null || _findError$error2 === void 0 ? void 0 : _findError$error2.message
                            };
                        }
                        return "";
                    }
                }
            ],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'partDetails',
            element: JobcardPartGrid,
            columnSize: 12,
            disabled: isDisabled || isFI,
            validator: function (value) {
                var findError = value === null || value === void 0 ? void 0 : value.find(function (item) { return item.error && item.error.message && item.IsActive && !item.IsDeleted; });
                if (findError) {
                    var _findError$error3, _findError$error4;
                    return {
                        field: findError === null || findError === void 0 || (_findError$error3 = findError.error) === null || _findError$error3 === void 0 ? void 0 : _findError$error3.field,
                        rowId: findError === null || findError === void 0 ? void 0 : findError.id,
                        id: nanoid(4),
                        message: findError === null || findError === void 0 || (_findError$error4 = findError.error) === null || _findError$error4 === void 0 ? void 0 : _findError$error4.message
                    };
                }
                return "";
            }
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'labour',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    paddingY: 0,
                    paddingX: 0.5,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'labourDetail',
                            label: '',
                            value: null,
                            children: 'Labour',
                            columnSize: 0,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$labourDet6;
                                var selectedLabours = formValues === null || formValues === void 0 || (_formValues$labourDet6 = formValues.labourDetails) === null || _formValues$labourDet6 === void 0 ? void 0 : _formValues$labourDet6.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                                return (selectedLabours === null || selectedLabours === void 0 ? void 0 : selectedLabours.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$labourDet7, _selectedLabours$leng;
                                var selectedLabours = formValues === null || formValues === void 0 || (_formValues$labourDet7 = formValues.labourDetails) === null || _formValues$labourDet7 === void 0 ? void 0 : _formValues$labourDet7.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_selectedLabours$leng = selectedLabours === null || selectedLabours === void 0 ? void 0 : selectedLabours.length) !== null && _selectedLabours$leng !== void 0 ? _selectedLabours$leng : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }],
                    columnSize: 12
                }],
            elements: [{
                    type: FormItemTypes.CheckBox,
                    name: 'SelectAllLabours',
                    label: '',
                    columnSize: 0,
                    hidden: isDisabled || isFI,
                    setFormState: function (state, checked) {
                        var _state$labourDetails2;
                        return {
                            labourDetails: state === null || state === void 0 || (_state$labourDetails2 = state.labourDetails) === null || _state$labourDetails2 === void 0 ? void 0 : _state$labourDetails2.map(function (p) { return _objectSpread(_objectSpread({}, p), {}, {
                                Selected: checked
                            }); })
                        };
                    },
                    formControlLabelProps: {
                        sx: {
                            m: 0
                        }
                    },
                    sx: {
                        bgcolor: 'white',
                        borderRadius: 2,
                        outline: '1px solid',
                        outlineColor: 'secondary.200',
                        outlineOffset: -1
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Startall',
                    columnSize: 0,
                    variant: "outlined",
                    color: 'primary',
                    children: 'Start all',
                    disabled: isDisabled || isFI,
                    setFormState: function (formValues) {
                        var _formValues$labourDet8, _formValues$labourDet9, _formValues$labourDet10, _formValues$labourDet11;
                        if ((formValues === null || formValues === void 0 || (_formValues$labourDet8 = formValues.labourDetails) === null || _formValues$labourDet8 === void 0 ? void 0 : _formValues$labourDet8.length) === 0) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You can not start all labour since no labour is present at service line.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet9 = formValues.labourDetails) !== null && _formValues$labourDet9 !== void 0 && _formValues$labourDet9.some(function (it) { return !(it !== null && it !== void 0 && it.TechnicianId); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot start all labour since mechanic is not allocated for some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet10 = formValues.labourDetails) !== null && _formValues$labourDet10 !== void 0 && _formValues$labourDet10.some(function (it) { return !(it !== null && it !== void 0 && it.ServiceTypeName); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot start all labour since job type is missing in some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet11 = formValues.labourDetails) !== null && _formValues$labourDet11 !== void 0 && _formValues$labourDet11.some(function (it) { return !(it !== null && it !== void 0 && it.HSNSACCode); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot start all labour since SAC code is missing in some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else {
                            var _formValues$labourDet12;
                            var updatedAllList = formValues === null || formValues === void 0 || (_formValues$labourDet12 = formValues.labourDetails) === null || _formValues$labourDet12 === void 0 ? void 0 : _formValues$labourDet12.map(function (item) {
                                var _getStatus3, _getStatus4;
                                if ((item === null || item === void 0 ? void 0 : item.StatusName) === StatusEnum.Started)
                                    return item;
                                var isNotCompleted = (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Completed;
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    ServiceStartDateTime: (item === null || item === void 0 ? void 0 : item.StatusName) === StatusEnum.Pause ? dayjs() : (item === null || item === void 0 ? void 0 : item.StatusName) === StatusEnum.Completed || item !== null && item !== void 0 && item.ServiceStartDateTime ? item === null || item === void 0 ? void 0 : item.ServiceStartDateTime : dayjs(),
                                    StatusName: isNotCompleted ? StatusEnum.Started : item === null || item === void 0 ? void 0 : item.StatusName,
                                    StatusId: isNotCompleted ? (_getStatus3 = getStatus(StatusEnum.Start)) === null || _getStatus3 === void 0 ? void 0 : _getStatus3.id : (_getStatus4 = getStatus(item === null || item === void 0 ? void 0 : item.StatusName)) === null || _getStatus4 === void 0 ? void 0 : _getStatus4.id,
                                    StatusKey: isNotCompleted ? StatusEnum.Started : item === null || item === void 0 ? void 0 : item.StatusKey,
                                    ServiceEndDateTime: isNotCompleted ? null : item !== null && item !== void 0 && item.ServiceEndDateTime ? item === null || item === void 0 ? void 0 : item.ServiceEndDateTime : dayjs(),
                                    PauseRemarks: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseRemarks,
                                    PauseReasonName: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonName,
                                    PauseReasonId: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonId
                                });
                            });
                            return {
                                labourDetails: updatedAllList
                            };
                        }
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Completeall',
                    columnSize: true,
                    variant: 'outlined',
                    color: 'primary',
                    children: 'Complete all',
                    setFormState: function (formValues) {
                        var _formValues$labourDet13, _formValues$labourDet14, _formValues$labourDet15, _formValues$labourDet16;
                        if ((formValues === null || formValues === void 0 || (_formValues$labourDet13 = formValues.labourDetails) === null || _formValues$labourDet13 === void 0 ? void 0 : _formValues$labourDet13.length) === 0) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You can not complete all labour since no labour is present at service line.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet14 = formValues.labourDetails) !== null && _formValues$labourDet14 !== void 0 && _formValues$labourDet14.some(function (it) { return !(it !== null && it !== void 0 && it.TechnicianId); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot complete all labour since technician is missing in some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet15 = formValues.labourDetails) !== null && _formValues$labourDet15 !== void 0 && _formValues$labourDet15.some(function (it) { return !(it !== null && it !== void 0 && it.ServiceTypeName); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot complete all labour since job type is missing in some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else if (formValues !== null && formValues !== void 0 && (_formValues$labourDet16 = formValues.labourDetails) !== null && _formValues$labourDet16 !== void 0 && _formValues$labourDet16.some(function (it) { return !(it !== null && it !== void 0 && it.HSNSACCode); })) {
                            return dispatch(showNotification({
                                isOpen: true,
                                message: "You cannot complete all labour since SAC code is missing in some of the service line labour.",
                                type: "error"
                            }));
                        }
                        else {
                            var _formValues$labourDet17;
                            var updatedAllList = formValues === null || formValues === void 0 || (_formValues$labourDet17 = formValues.labourDetails) === null || _formValues$labourDet17 === void 0 ? void 0 : _formValues$labourDet17.map(function (item) {
                                var _getStatus5;
                                var isNotCompleted = (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Completed;
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    ServiceEndDateTime: (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Pause ? item !== null && item !== void 0 && item.ServiceEndDateTime ? item === null || item === void 0 ? void 0 : item.ServiceEndDateTime : dayjs() : dayjs(),
                                    ServiceStartDateTime: item !== null && item !== void 0 && item.ServiceStartDateTime ? item === null || item === void 0 ? void 0 : item.ServiceStartDateTime : dayjs(),
                                    StatusId: (_getStatus5 = getStatus(StatusEnum.Completed)) === null || _getStatus5 === void 0 ? void 0 : _getStatus5.id,
                                    StatusKey: StatusEnum.Completed,
                                    StatusName: StatusEnum.Completed,
                                    PauseRemarks: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseRemarks,
                                    PauseReasonName: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonName,
                                    PauseReasonId: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonId
                                });
                            });
                            return {
                                labourDetails: updatedAllList
                            };
                        }
                    },
                    disabled: isDisabled || isFI
                }, {
                    type: FormItemTypes.Button,
                    name: 'delete-labourDetails',
                    children: /*#__PURE__*/ React.createElement(Delete, null),
                    size: 'icon',
                    variant: 'outlined',
                    color: 'secondary',
                    hidden: isDisabled || isFI,
                    columnSize: 0,
                    setFieldProps: function (state) {
                        var _state$labourDetails3;
                        return {
                            disabled: !(state !== null && state !== void 0 && (_state$labourDetails3 = state.labourDetails) !== null && _state$labourDetails3 !== void 0 && _state$labourDetails3.some(function (item) { return item === null || item === void 0 ? void 0 : item.Selected; }))
                        };
                    },
                    setFormState: function (state) { return __awaiter(void 0, void 0, void 0, function () {
                        var _state$labourDetails4, updatedLaboursList, req, validateResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    updatedLaboursList = (_state$labourDetails4 = state.labourDetails) === null || _state$labourDetails4 === void 0 ? void 0 : _state$labourDetails4.map(function (item) {
                                        if (item.Selected) {
                                            return _objectSpread(_objectSpread({}, item), {}, {
                                                "UserDeleted": item.Selected,
                                                "IsActive": false,
                                                "IsDeleted": true
                                            });
                                        }
                                        else {
                                            return _objectSpread(_objectSpread({}, item), {}, {
                                                "UserDeleted": false
                                            });
                                        }
                                    });
                                    if (!(updatedLaboursList !== null && updatedLaboursList !== void 0 && updatedLaboursList.length))
                                        return [2 /*return*/];
                                    req = {
                                        "SystemName": "Labours",
                                        "Labours": updatedLaboursList
                                    };
                                    return [4 /*yield*/, validateDeletePartLabour({
                                            request: req
                                        })];
                                case 1:
                                    validateResponse = _a.sent();
                                    if (validateResponse.success && validateResponse.statusCode === 200) {
                                        return [2 /*return*/, {
                                                labourDetails: updatedLaboursList,
                                                SelectAllLabours: false
                                            }];
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.List,
                    name: 'labourDetails',
                    columnSize: 12,
                    value: null,
                    getRowHeight: function () { return 'auto'; },
                    validator: function (values) {
                        var error = undefined;
                        values === null || values === void 0 || values.find(function (_it) {
                            if (!(_it !== null && _it !== void 0 && _it.IsActive) || _it !== null && _it !== void 0 && _it.IsDeleted)
                                return false;
                            if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.ServiceTypeName)) {
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: 'You cannont leave job type blank since it is mandatory.',
                                    type: "error"
                                }));
                            }
                            else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.HSNSACCode)) {
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: 'You cannont leave SAC Code type blank since it is mandatory.',
                                    type: "error"
                                }));
                            }
                            else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.TechnicianName)) {
                                error = {
                                    id: v4(),
                                    rowId: _it.id,
                                    field: 'TechnicianName',
                                    message: "You cannont leave 'Technician Name' blank since status is ".concat(_it === null || _it === void 0 ? void 0 : _it.StatusName, "."),
                                    value: _it['TechnicianName']
                                };
                                return true;
                            }
                            else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) === StatusEnum.Pause && !(_it !== null && _it !== void 0 && _it.PauseRemarks)) {
                                error = {
                                    id: v4(),
                                    rowId: _it.id,
                                    field: 'PauseRemarks',
                                    message: "You cannont leave 'Pause Remark' blank since it is mandatory.",
                                    value: _it['PauseRemarks']
                                };
                                return true;
                            }
                            else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) === StatusEnum.Pause && !(_it !== null && _it !== void 0 && _it.PauseReasonId)) {
                                error = {
                                    id: v4(),
                                    rowId: _it.id,
                                    field: 'PauseReasonId',
                                    message: "You cannont leave 'Pause Reason' blank since it is mandatory.",
                                    value: _it['PauseReasonId']
                                };
                                return true;
                            }
                        });
                        return error;
                    },
                    disableCheckboxSelection: isDisabled || isFI,
                    columns: [{
                            field: 'Labour',
                            flex: 1,
                            renderCell: function (_ref4) {
                                var row = _ref4.row;
                                return /*#__PURE__*/ React.createElement(Stack, {
                                    py: '12px'
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    id: "labour-name",
                                    fontSize: "lg",
                                    fontWeight: "medium",
                                    sx: {
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        wordBreak: 'break-word'
                                    }
                                }, row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    id: "labour-code",
                                    color: "secondary"
                                }, row.ChildCode ? '#' + row.ChildCode : ''));
                            }
                        }],
                    elements: labourElements,
                    valueGetter: function (formValues, field) {
                        var _formValues$labourDet18;
                        return (formValues === null || formValues === void 0 || (_formValues$labourDet18 = formValues.labourDetails) === null || _formValues$labourDet18 === void 0 ? void 0 : _formValues$labourDet18.filter(function (item) { return !item.IsDeleted; })) || [];
                    },
                    sx: {
                        bgcolor: 'white'
                    },
                    disabled: isDisabled || isFI
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'labourDetails',
            element: JobcardLabourGrid,
            disabled: isDisabled || isFI,
            validator: function (values) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (_it) {
                    var _dayjs;
                    if (!(_it !== null && _it !== void 0 && _it.IsActive) || _it !== null && _it !== void 0 && _it.IsDeleted)
                        return false;
                    if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.ServiceTypeName)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: 'You cannont leave job type blank since it is mandatory.',
                            type: "error"
                        }));
                    }
                    else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.HSNSACCode)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: 'You cannont leave SAC Code type blank since it is mandatory.',
                            type: "error"
                        }));
                    }
                    else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) !== StatusEnum.Awaiting && !(_it !== null && _it !== void 0 && _it.TechnicianName)) {
                        error = {
                            id: v4(),
                            rowId: _it.id,
                            field: 'TechnicianName',
                            message: "You cannont leave 'Technician Name' blank since status is ".concat(_it === null || _it === void 0 ? void 0 : _it.StatusName, "."),
                            value: _it['TechnicianName']
                        };
                        return true;
                    }
                    else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) === StatusEnum.Pause && !(_it !== null && _it !== void 0 && _it.PauseRemarks)) {
                        error = {
                            id: v4(),
                            rowId: _it.id,
                            field: 'PauseRemarks',
                            message: "You cannont leave 'Pause Remark' blank since it is mandatory.",
                            value: _it['PauseRemarks']
                        };
                        return true;
                    }
                    else if ((_it === null || _it === void 0 ? void 0 : _it.StatusName) === StatusEnum.Pause && !(_it !== null && _it !== void 0 && _it.PauseReasonName)) {
                        error = {
                            id: v4(),
                            rowId: _it.id,
                            field: 'PauseReasonName',
                            message: "You cannont leave 'Pause Reason' blank since it is mandatory.",
                            value: _it['PauseReasonName']
                        };
                        return true;
                    }
                    else if ((_dayjs = dayjs(_it === null || _it === void 0 ? void 0 : _it.ServiceStartDateTime)) !== null && _dayjs !== void 0 && _dayjs.isBefore(dayjs(_it === null || _it === void 0 ? void 0 : _it.JCCreationDate))) {
                        error = {
                            id: v4(),
                            rowId: _it.id,
                            field: 'ServiceStartDateTime',
                            message: "Start date time should be greater than document creation date time.",
                            value: _it['ServiceStartDateTime']
                        };
                        return true;
                    }
                });
                return error;
            },
            columnSize: 12
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12,
            sx: {
                display: IS_MOBILE ? 'none' : 'block'
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                mt: 0
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'GrandTotalMenu',
                    variant: 'outlined',
                    fullWidth: true,
                    color: 'secondary',
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    setFieldProps: function (formValues) {
                        var totalAmount = 0;
                        if (formValues) {
                            var _formValues$partDetai5, _formValues$labourDet19;
                            var selectedParts = formValues === null || formValues === void 0 || (_formValues$partDetai5 = formValues.partDetails) === null || _formValues$partDetai5 === void 0 ? void 0 : _formValues$partDetai5.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                            var selectedLabours = formValues === null || formValues === void 0 || (_formValues$labourDet19 = formValues.labourDetails) === null || _formValues$labourDet19 === void 0 ? void 0 : _formValues$labourDet19.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                            var totalPartAmount = selectedParts === null || selectedParts === void 0 ? void 0 : selectedParts.reduce(function (acc, cur) { return reduceArray(acc, cur, 'labourDetails'); }, 0);
                            var totalLabourAmount = selectedLabours === null || selectedLabours === void 0 ? void 0 : selectedLabours.reduce(function (acc, cur) { return reduceArray(acc, cur, 'partDetails'); }, 0);
                            var validTotalPartAmount = isNaN(totalPartAmount) ? 0 : totalPartAmount;
                            var validTotalLabourAmount = isNaN(totalLabourAmount) ? 0 : totalLabourAmount;
                            totalAmount = validTotalPartAmount + validTotalLabourAmount;
                        }
                        return {
                            type: FormItemTypes.Button,
                            children: /*#__PURE__*/ React.createElement(Stack, {
                                width: '100%',
                                justifyContent: 'space-between',
                                direction: 'row'
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                fontWeight: 'strong'
                            }, "Total amount"), /*#__PURE__*/ React.createElement(Typography, {
                                id: "total-amount",
                                fontWeight: 'strong'
                            }, "\u20B9 ".concat(totalAmount.toFixed(2))))
                        };
                    }
                    // only UAT v2.5
                    // setFormState: async (formValues, e) => {
                    //     let totalAmount: ITotalAmount = {
                    //         paidAmount: 0,
                    //         expensesAmount: 0,
                    //         claimAmount: 0
                    //     };
                    //     if (formValues) {
                    //         const calculateAmount = (type: InvoicesTypes_E) => {
                    //             const selectedParts = formValues?.partDetails?.filter((item: any) => !item?.IsDeleted && InvoicesTypes[item?.PostingTypeValue] === type);
                    //             const selectedLabours = formValues?.labourDetails?.filter((item: any) => !item?.IsDeleted && InvoicesTypes[item?.PostingTypeValue] === type);
                    //             const totalPartAmount = selectedParts?.reduce((acc: number, cur: any) => reduceArray(acc, cur, 'labourDetails'), 0);
                    //             const totalLabourAmount = selectedLabours?.reduce((acc: number, cur: any) => reduceArray(acc, cur, 'partDetails'), 0);
                    //             const validPartAmount = isNaN(totalPartAmount) ? 0 : totalPartAmount;
                    //             const validLabourAmount = isNaN(totalLabourAmount) ? 0 : totalLabourAmount;
                    //             return validPartAmount + validLabourAmount;
                    //         };
                    //         totalAmount.paidAmount = calculateAmount(InvoicesTypes_E.Paid);
                    //         totalAmount.expensesAmount = calculateAmount(InvoicesTypes_E.Expenses);
                    //         totalAmount.claimAmount = calculateAmount(InvoicesTypes_E.GenerateClaims);
                    //     }
                    //     let rect = ((e?.target as HTMLButtonElement)?.closest('button')?.getBoundingClientRect())
                    //     const res = isMobile ? await dispatch(showSurface({
                    //         type: 'Drawer',
                    //         Component: JobCardTotalAmountPopup,
                    //         containerProps: {
                    //             anchor: 'bottom',
                    //             PaperProps: {
                    //                 sx: {
                    //                     borderRadius: '8px 8px 0 0',
                    //                 }
                    //             }
                    //         },
                    //         componentProps: {
                    //             formValues,
                    //             totalAmount
                    //         }
                    //     })) : dispatch(showSurface({
                    //         type: 'Menu',
                    //         Component: JobCardTotalAmountPopup,
                    //         componentProps: {
                    //             formValues,
                    //             totalAmount
                    //         },
                    //         containerProps: {
                    //             anchorEl: e?.target?.closest('#GrandTotalMenu'),
                    //             anchorOrigin: {
                    //                 vertical: 'top',
                    //                 horizontal: 'right',
                    //             },
                    //             transformOrigin: {
                    //                 vertical: 'top',
                    //                 horizontal: 'right',
                    //             },
                    //             slotProps: {
                    //                 paper: {
                    //                     sx: {
                    //                         bottom: `calc(100svh - ${((rect?.top ?? 0) - 10)}px)`,
                    //                         top: 'unset !important',
                    //                     }
                    //                 }
                    //             }
                    //         },
                    //     }));
                    // },
                    // startIcon: <RightArrow id='total-amount-expand-icon' color='text.secondary' height={20} width={20} />,
                }]
        }];
    var warrantyAndFieldFixFields = [isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'warranty',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    paddingY: 0,
                    paddingX: 0.5,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'warranty',
                            label: '',
                            value: null,
                            children: 'Warranty details',
                            sx: {
                                textWrap: 'nowrap'
                            },
                            columnSize: 0,
                            variant: "h5"
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$warrantyL;
                                return (formValues === null || formValues === void 0 || (_formValues$warrantyL = formValues.warrantyList) === null || _formValues$warrantyL === void 0 ? void 0 : _formValues$warrantyL.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$warrantyL2, _formValues$warrantyL3;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$warrantyL2 = formValues === null || formValues === void 0 || (_formValues$warrantyL3 = formValues.warrantyList) === null || _formValues$warrantyL3 === void 0 ? void 0 : _formValues$warrantyL3.length) !== null && _formValues$warrantyL2 !== void 0 ? _formValues$warrantyL2 : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }]
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    freeSolo: true,
                    multiple: true,
                    disableCloseOnSelect: true,
                    renderTags: function () { return null; },
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.List,
                    name: 'warrantyList',
                    columnSize: 12,
                    value: null,
                    disableCheckboxSelection: isDisabled,
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    columns: [{
                            field: 'Labour',
                            flex: 1,
                            renderCell: function (_ref5) {
                                var row = _ref5.row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    id: "warranty-part-name",
                                    variant: "h3"
                                }, row.PartName), /*#__PURE__*/ React.createElement(Typography, {
                                    id: "warranty-part-code",
                                    variant: "h6",
                                    color: "secondary"
                                }, row.PartCode ? '#' + row.PartCode : ''));
                            }
                        }],
                    elements: warrantyListElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'warrantyList',
            element: WarrantyDetails,
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'recallPart',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    paddingY: 0,
                    paddingX: 0.5,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'recallPart',
                            label: '',
                            value: null,
                            children: 'Recall parts',
                            sx: {
                                textWrap: 'nowrap'
                            },
                            columnSize: 0,
                            variant: "h5"
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$recallPar;
                                return (formValues === null || formValues === void 0 || (_formValues$recallPar = formValues.recallPartList) === null || _formValues$recallPar === void 0 ? void 0 : _formValues$recallPar.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$recallPar2, _formValues$recallPar3;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$recallPar2 = formValues === null || formValues === void 0 || (_formValues$recallPar3 = formValues.recallPartList) === null || _formValues$recallPar3 === void 0 ? void 0 : _formValues$recallPar3.length) !== null && _formValues$recallPar2 !== void 0 ? _formValues$recallPar2 : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }]
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    freeSolo: true,
                    multiple: true,
                    disableCloseOnSelect: true,
                    renderTags: function () { return null; },
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.List,
                    name: 'warrantyList',
                    columnSize: 12,
                    value: [{
                            id: 0
                        }, {
                            id: 1
                        }],
                    disableCheckboxSelection: isDisabled,
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    columns: [{
                            field: 'Labour',
                            flex: 1,
                            renderCell: function (_ref6) {
                                var row = _ref6.row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    id: "recall-part-name",
                                    variant: "h3"
                                }, row.PartName), /*#__PURE__*/ React.createElement(Typography, {
                                    id: "recall-part-id",
                                    variant: "h6",
                                    color: "secondary"
                                }, row.PartCode ? '#' + row.PartCode : ''));
                            }
                        }],
                    elements: recallPartElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'recallPartdetails',
            element: RecallPartGrid,
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'RecallLabour',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    paddingY: 0,
                    paddingX: 0.5,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'RecallLabour',
                            label: '',
                            value: null,
                            children: 'Recall labours',
                            sx: {
                                textWrap: 'nowrap'
                            },
                            columnSize: 0,
                            variant: "h5"
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$RecallLab;
                                return (formValues === null || formValues === void 0 || (_formValues$RecallLab = formValues.RecallLabourList) === null || _formValues$RecallLab === void 0 ? void 0 : _formValues$RecallLab.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$RecallLab2, _formValues$RecallLab3;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$RecallLab2 = formValues === null || formValues === void 0 || (_formValues$RecallLab3 = formValues.RecallLabourList) === null || _formValues$RecallLab3 === void 0 ? void 0 : _formValues$RecallLab3.length) !== null && _formValues$RecallLab2 !== void 0 ? _formValues$RecallLab2 : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }]
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    freeSolo: true,
                    multiple: true,
                    disableCloseOnSelect: true,
                    renderTags: function () { return null; },
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.List,
                    name: 'recallLabourList',
                    columnSize: 12,
                    value: [{
                            id: 0
                        }, {
                            id: 1
                        }],
                    disableCheckboxSelection: isDisabled,
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    columns: [{
                            field: 'Labour',
                            flex: 1,
                            renderCell: function (_ref7) {
                                var row = _ref7.row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, row.PartName), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, row.PartCode ? '#' + row.PartCode : ''));
                            }
                        }],
                    elements: recallLabourElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'recallPartdetails',
            element: RecallLabourGrid,
            columnSize: 12
        }];
    var reworkFields = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: 'jobCardReworkTab',
                    element: JobCardReworkTab,
                    columnSize: 12
                }]
        }];
    var warrantyFields = [checkModuleSectionUISettingMandatory(EModuleSection.AdvisorSuggestions) ? {
            type: FormItemTypes.Custom,
            name: 'Suggestions',
            label: 'Suggestions',
            element: function () {
                var _documentDetailsGetBy68;
                return /*#__PURE__*/ React.createElement(AdvisorSuggestions, {
                    installBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy68 = documentDetailsGetById.data) === null || _documentDetailsGetBy68 === void 0 ? void 0 : _documentDetailsGetBy68.InstallBaseId,
                    documentId: id,
                    isDisabled: isDisabled,
                    documentType: 'JobCard',
                    onSave: function (updatedSuggestions) { return setSuggestions(updatedSuggestions); }
                });
            },
            columnSize: 12
        } : null, checkModuleSectionUISettingMandatory(EModuleSection.FutureAdvise) ? {
            type: FormItemTypes.Custom,
            label: 'Future advise',
            containerProps: {
                mt: IS_MOBILE ? 2 : 0
            },
            name: 'futureAdviseDetails',
            element: function () { /*#__PURE__*/ return React.createElement(FutureAdviseGrid, {
                isDisabled: isDisabled,
                documentId: id,
                documentData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
                documentType: 'JobCard',
                onSave: function (updatedFutureAdvise) { return setFutureAdviseList(updatedFutureAdvise); }
            }); },
            columnSize: 12
        } : null];
    var formData = [{
            type: FormItemTypes.Custom,
            name: "getSocketUpdates",
            element: GetSocketUpdates,
            valueSetter: function (formValues, currValue) {
                return currValue;
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            px: {
                xs: 2,
                sm: 3
            },
            py: 2,
            position: 'relative',
            m: 0,
            spacing: 0,
            justifyContent: 'space-between',
            rowGap: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    spacing: 0,
                    alignItems: 'center',
                    columnSpacing: 1,
                    flexWrap: 'nowrap',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, {
                                id: "back-arrow"
                            }),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: handleBackClick
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'jobCard',
                            value: 'Job card details',
                            fontWeight: 'strong',
                            fontSize: {
                                xs: 'lg',
                                sm: 'xxl',
                                md: 'lg'
                            },
                            columnSize: 0,
                            noWrap: true
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'StatusName',
                            columnSize: 0,
                            setFieldProps: function (formValues, currValue) {
                                var _getStatusColor;
                                return {
                                    color: (_getStatusColor = getStatusColor(currValue !== null && currValue !== void 0 ? currValue : '')) === null || _getStatusColor === void 0 ? void 0 : _getStatusColor.color,
                                    hidden: !currValue
                                };
                            },
                            value: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy69 = documentDetailsGetById.data) === null || _documentDetailsGetBy69 === void 0 ? void 0 : _documentDetailsGetBy69.StatusName,
                            shape: 'rounded',
                            size: 'medium'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'down-arrow',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(HistoryRounded, {
                                color: "secondary",
                                sx: {
                                    height: 24,
                                    width: 24
                                }
                            }),
                            columnSize: 0,
                            onClick: onClickStatusStepperIcon,
                            size: 'small',
                            sx: {
                                p: 0.25
                            },
                            disableRipple: true
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: true
                        }, IS_MOBILE ? !((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy70 = documentDetailsGetById.data) === null || _documentDetailsGetBy70 === void 0 ? void 0 : _documentDetailsGetBy70.Key) == StatusEnum.Awaiting || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy71 = documentDetailsGetById.data) === null || _documentDetailsGetBy71 === void 0 ? void 0 : _documentDetailsGetBy71.Key) === StatusEnum.Cancelled) ? {
                            type: FormItemTypes.IconButton,
                            name: 'kebab-btn',
                            children: /*#__PURE__*/ React.createElement(MoreVert, {
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                Component: JobCardMoreAction,
                                                containerProps: {
                                                    anchorEl: e === null || e === void 0 ? void 0 : e.currentTarget
                                                },
                                                componentProps: {
                                                    menus: menus
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            if (res !== null && res !== void 0 && res.payload) {
                                                handleMenusClick(res === null || res === void 0 ? void 0 : res.payload, state);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 0,
                    spacing: 0,
                    columnSpacing: 2,
                    alignItems: 'center',
                    justifyContent: 'end',
                    flexBasis: {
                        sm: 'auto'
                    },
                    width: {
                        xs: '100%',
                        sm: 'auto'
                    },
                    flexWrap: {
                        sm: 'nowrap'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'SourceDocumentNo',
                            label: 'JC NO:',
                            value: '-',
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignContent: 'center',
                                justifyContent: {
                                    xs: 'space-between',
                                    sm: 'end'
                                },
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium'
                            },
                            xs: 12,
                            sm: 0,
                            md: 0,
                            noWrap: true,
                            fontSize: 'sm'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'JobCardDate',
                            label: 'JC DATE:',
                            // value: `${dateFormate(documentDetailsGetById?.data?.JobCardDate)}`,
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                justifyContent: {
                                    xs: 'space-between',
                                    sm: 'end'
                                },
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium'
                            },
                            xs: 12,
                            sm: 0,
                            md: 0,
                            valueGetter: function (state, field) {
                                var _field$name, _field$name2;
                                return state !== null && state !== void 0 && state[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? "".concat(dateFormate(state === null || state === void 0 ? void 0 : state[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : ''])) : '-';
                            },
                            noWrap: true,
                            fontSize: 'sm'
                        }, !IS_MOBILE ? !((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy72 = documentDetailsGetById.data) === null || _documentDetailsGetBy72 === void 0 ? void 0 : _documentDetailsGetBy72.Key) == StatusEnum.Awaiting || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy73 = documentDetailsGetById.data) === null || _documentDetailsGetBy73 === void 0 ? void 0 : _documentDetailsGetBy73.Key) === StatusEnum.Cancelled) ? {
                            type: FormItemTypes.IconButton,
                            name: '',
                            id: 'jobcard-more-actions',
                            children: /*#__PURE__*/ React.createElement(MoreVert, {
                                color: "secondary"
                            }),
                            columnSize: 0,
                            // onClick: handleClick
                            onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                Component: JobCardMoreAction,
                                                containerProps: {
                                                    anchorEl: e === null || e === void 0 ? void 0 : e.currentTarget
                                                },
                                                componentProps: {
                                                    menus: menus
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            if (res !== null && res !== void 0 && res.payload) {
                                                handleMenusClick(res === null || res === void 0 ? void 0 : res.payload, state);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null : null]
                }]
        }, !IS_MOBILE ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            py: 2,
            px: 3,
            spacing: 0,
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.CheckBox,
                    name: 'ReadyForInvoice',
                    label: 'Ready for invoice',
                    columnSize: 0,
                    labelTypographyProps: {
                        fontSize: 'sm'
                    },
                    formControlLabelProps: {
                        labelPlacement: 'end'
                    },
                    disabled: true // only UAT v2.5
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    justifyContent: 'end',
                    columnSize: 0,
                    spacing: 0,
                    columnSpacing: 1.5,
                    width: 'auto',
                    elements: [
                        // only UAT v2.5
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'quick-links',
                        //     variant: 'text',
                        //     disabled: isDisabled,
                        //     children: IS_DESKTOP ? 'Quick links' : null,
                        //     columnSize: 0,
                        //     startIcon: <LinkSvg />,
                        // },
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'download',
                        //     children: <Download />,
                        //     columnSize: 0,
                        //     variant: 'outlined',
                        //     disabled: true,
                        //     size: 'icon',
                        //     color: 'secondary',
                        // },
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'share',
                        //     children: <ShareLineSvgIcon />,
                        //     columnSize: 0,
                        //     variant: 'outlined',
                        //     disabled: true,
                        //     size: 'icon',
                        //     color: 'secondary'
                        // },
                        {
                            type: FormItemTypes.Button,
                            name: 'print',
                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PrintIconSVG, null), " ", /*#__PURE__*/ React.createElement(Divider, {
                                orientation: "vertical",
                                variant: "fullWidth",
                                flexItem: true,
                                sx: {
                                    my: -1,
                                    mx: 1
                                }
                            }), " "),
                            endIcon: /*#__PURE__*/ React.createElement(DropDownIconNew, {
                                sx: {
                                    mx: -0.5
                                }
                            }),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            disabled: isDisabledPrint,
                            size: 'icon',
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var _e$target, res, res_3, res_4;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                Component: ActionMenuList,
                                                containerProps: {
                                                    anchorEl: e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest('button'),
                                                    slotProps: {
                                                        paper: {
                                                            sx: {
                                                                px: 0.5
                                                            }
                                                        }
                                                    }
                                                },
                                                componentProps: {
                                                    items: [{
                                                            id: 'CustomerPrint',
                                                            children: ["JobCardPrint.pdf"]
                                                        }
                                                        // {
                                                        //     id: 'TechnicianPrint',
                                                        //     children: ["TechnicianPrint.pdf"]
                                                        // },
                                                    ]
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            if (!((res === null || res === void 0 ? void 0 : res.payload) === "CustomerPrint")) return [3 /*break*/, 3];
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: CombineJCPrint,
                                                    // Component: CustomerJCPrintPreview,
                                                    containerProps: {
                                                        maxWidth: 'sm'
                                                    },
                                                    componentProps: {
                                                        data: state
                                                    }
                                                }))];
                                        case 2:
                                            res_3 = _a.sent();
                                            _a.label = 3;
                                        case 3:
                                            if (!((res === null || res === void 0 ? void 0 : res.payload) === "TechnicianPrint")) return [3 /*break*/, 5];
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: TechnicianPrintPreview,
                                                    containerProps: {
                                                        maxWidth: 'sm'
                                                    },
                                                    componentProps: {
                                                        data: state
                                                    }
                                                }))];
                                        case 4:
                                            res_4 = _a.sent();
                                            _a.label = 5;
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            }); }
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        },
                        // only UAT v2.5
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'cancel-jc',
                        //     children: 'Cancel JC',
                        //     color: 'secondary',
                        //     columnSize: 0,
                        //     onClick: async (params, formValues, Api) => {
                        //         let res = await dispatch(showSurface({
                        //             type: 'Dialog',
                        //             Component: NewCancelPopup,
                        //             componentProps: { state: formValues?.JobCardId },
                        //             //containerProps: drawerContainerProps,
                        //         }))
                        //         if (res?.payload) {
                        //             dispatch(
                        //                 showNotification({
                        //                     isOpen: true,
                        //                     message: "JobCard Cancellation Succesfully done",
                        //                     type: "success",
                        //                 })
                        //             );
                        //             navigate("/jobCard")
                        //         }
                        //     },
                        //     setFieldProps(formValues) {
                        //         return {
                        //             disabled: formValues?.Key === StatusEnum.Cancelled
                        //         }
                        //     },
                        // },
                        REVISED_ESTIMATE_BTN, SAVE_BTN, START_FI_BTN
                    ]
                }]
        } : null, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy74 = documentDetailsGetById.data) !== null && _documentDetailsGetBy74 !== void 0 && (_documentDetailsGetBy74 = _documentDetailsGetBy74.SourceMessage) !== null && _documentDetailsGetBy74 !== void 0 && _documentDetailsGetBy74.ErrorMessage ? {
            type: FormItemTypes.Chip,
            name: 'CDMSError',
            columnSize: 12,
            color: 'error',
            shape: 'rounded',
            size: 'large',
            icon: /*#__PURE__*/ React.createElement(ErrorOutlineRounded, null),
            valueGetter: function (formValues) {
                var _formValues$SourceMes;
                return formValues === null || formValues === void 0 || (_formValues$SourceMes = formValues.SourceMessage) === null || _formValues$SourceMes === void 0 ? void 0 : _formValues$SourceMes.ErrorMessage;
            },
            setFieldProps: function (formValues, currValue) {
                return {
                    hidden: !Boolean(currValue)
                };
            },
            containerProps: {
                px: {
                    xs: 2,
                    sm: 3
                },
                py: 2
            }
        } : null, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 12,
            containerProps: {
                spacing: 0,
                marginTop: '-10px',
                marginInline: '8px'
            },
            element: function () {
                var _documentDetailsGetBy75, _documentDetailsGetBy76, _documentDetailsGetBy77, _documentDetailsGetBy78, _documentDetailsGetBy79, _documentDetailsGetBy80, _documentDetailsGetBy81;
                return /*#__PURE__*/ React.createElement(OptionAlert, {
                    documentStatusKey: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy75 = documentDetailsGetById.data) === null || _documentDetailsGetBy75 === void 0 ? void 0 : _documentDetailsGetBy75.Key,
                    isCreateDocumentFlow: false,
                    jobCardId: id !== null && id !== void 0 ? id : "",
                    JobcardNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy76 = documentDetailsGetById.data) === null || _documentDetailsGetBy76 === void 0 ? void 0 : _documentDetailsGetBy76.JobCardNo,
                    difference: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy77 = documentDetailsGetById.data) !== null && _documentDetailsGetBy77 !== void 0 && _documentDetailsGetBy77.EstimateDeliveryDateTime ? moment().diff(moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy78 = documentDetailsGetById.data) === null || _documentDetailsGetBy78 === void 0 ? void 0 : _documentDetailsGetBy78.EstimateDeliveryDateTime), 'minutes') : 0,
                    EstimatedDateTime: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy79 = documentDetailsGetById.data) !== null && _documentDetailsGetBy79 !== void 0 && _documentDetailsGetBy79.EstimateDeliveryDateTime ? moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy80 = documentDetailsGetById.data) === null || _documentDetailsGetBy80 === void 0 ? void 0 : _documentDetailsGetBy80.EstimateDeliveryDateTime).format('DD MMM, YYYY - h:mm A') : "",
                    previousJobcard: previousJobcard,
                    InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy81 = documentDetailsGetById.data) === null || _documentDetailsGetBy81 === void 0 ? void 0 : _documentDetailsGetBy81.InstallBaseId,
                    isDocumentDisabled: RepeatAlertDisabledForJC
                });
            }
        } : null, {
            type: FormItemTypes.ErrorsPanel,
            name: 'ErrorsPanel'
            // columnSize: 12,
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            columnSize: 12,
            valueExpr: 'id',
            displayExpr: 'Name',
            panelGridProps: {
                spacing: {
                    xs: 0,
                    sm: 2.5
                },
                pb: {
                    xs: 8,
                    sm: 0
                }
            },
            containerProps: {
                px: {
                    xs: 2,
                    sm: 3
                },
                pt: {
                    xs: 0.5,
                    sm: 1
                }
            },
            tabs: __spreadArray(__spreadArray([{
                    id: 'general',
                    Name: 'General',
                    elements: generalFields,
                    containerProps: {
                        spacing: {
                            xs: 2,
                            sm: 2.5
                        }
                    }
                }, {
                    id: 'PartsLabour',
                    Name: 'Parts & Labour',
                    elements: partandlabourField
                }], (checkModuleSectionUISettingMandatory(EModuleSection.FutureAdvise) || checkModuleSectionUISettingMandatory(EModuleSection.AdvisorSuggestions) ? [{
                    id: 'Warranty',
                    Name: 'Others',
                    elements: warrantyFields
                }] : []), true), (FIRejectedItemsCount > 0 && showReworkTabConditionBasedOnStatus() ? [{
                    id: 'Rework',
                    Name: 'Rework',
                    elements: reworkFields
                }] : []), true)
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: systemColor.grey,
                gap: '16px'
            },
            elements: [REVISED_ESTIMATE_BTN, SAVE_BTN, START_FI_BTN]
        } : null];
    var lgMode = useMediaQuery('(min-width:600px)');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: showDeliveredDialog,
        closeIcon: true,
        onClose: function () { return setShowDeliveredDialog(false); },
        backdropEnable: true,
        padding: '15px 0px 0px 15px',
        headerIcon: YellowWarningIcon,
        containerStyle: {
            width: lgMode ? '500px' : 'calc(80vw)'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        id: "submitted-successfully-popup"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "16px"
    }, t("JobCard is ".concat((documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy82 = documentDetailsGetById.data) === null || _documentDetailsGetBy82 === void 0 ? void 0 : _documentDetailsGetBy82.StatusName), " !"))), /*#__PURE__*/ React.createElement(Typography, {
        id: "FI-JC-No",
        fontSize: "12px",
        color: '#6A7682',
        marginTop: 1
    }, t("".concat((_documentDetailsGetBy83 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy84 = documentDetailsGetById.data) === null || _documentDetailsGetBy84 === void 0 ? void 0 : _documentDetailsGetBy84.SourceDocumentNo) !== null && _documentDetailsGetBy83 !== void 0 ? _documentDetailsGetBy83 : "", " - JC ").concat((documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy85 = documentDetailsGetById.data) === null || _documentDetailsGetBy85 === void 0 ? void 0 : _documentDetailsGetBy85.StatusName), " Successfully")))), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            paddingTop: '20px'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "small",
        variant: "contained",
        name: t("BACK_TO_HOME"),
        onClick: handleBackToHomeClick,
        fullWidth: true
    })))), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: 'edit',
        onChange: function (e, params) {
            var _state$labourDetails5, _state$labourDetails6, _state$labourDetails7, _state$labourDetails8, _state$labourDetails9, _state$labourDetails10, _state$labourDetails11;
            if (isDisabled)
                return;
            var field = params.field, state = params.state;
            if (field !== null && field !== void 0 && field.type && inputFieldTypes.has(field.type)) {
                setIsdataAlter(true);
            }
            switch (field === null || field === void 0 ? void 0 : field.name) {
                case 'save-btn':
                    return;
                case 'labourDetails':
                case 'TechnicianId':
                case 'Completeall':
                case 'Startall':
                    console.log("is i am in ....");
                    if (!(state !== null && state !== void 0 && (_state$labourDetails5 = state.labourDetails) !== null && _state$labourDetails5 !== void 0 && _state$labourDetails5.length))
                        return;
                    var isWorkCompleted = state === null || state === void 0 || (_state$labourDetails6 = state.labourDetails) === null || _state$labourDetails6 === void 0 ? void 0 : _state$labourDetails6.every(function (item) { return item.StatusName === StatusEnum.Completed; });
                    if ((state === null || state === void 0 ? void 0 : state.Key) === StatusEnum.Rework && isWorkCompleted)
                        return;
                    var isLabourDeleted = state === null || state === void 0 || (_state$labourDetails7 = state.labourDetails) === null || _state$labourDetails7 === void 0 ? void 0 : _state$labourDetails7.every(function (item) { return item.IsDeleted && !item.IsActive; });
                    if (isLabourDeleted) {
                        // updateDocumentStatus("Open", StatusEnum.ReadyForWork);
                        return {
                            Key: StatusEnum.ReadyForWork,
                            StatusName: "Open"
                        };
                    }
                    var isWorkStarted = state === null || state === void 0 || (_state$labourDetails8 = state.labourDetails) === null || _state$labourDetails8 === void 0 ? void 0 : _state$labourDetails8.some(function (item) { return item.StatusName === StatusEnum.Started || item.StatusName === StatusEnum.Pause; });
                    if (isWorkStarted) {
                        // updateDocumentStatus("Work In Progress", StatusEnum.WorkStarted);
                        return {
                            Key: StatusEnum.WorkStarted,
                            StatusName: "Work In Progress"
                        };
                    }
                    if (isWorkCompleted) {
                        // updateDocumentStatus("Work Completed", StatusEnum.WorkCompleted);
                        return {
                            Key: StatusEnum.WorkCompleted,
                            StatusName: "Work Completed"
                        };
                    }
                    var isSomeWorkCompleted = state === null || state === void 0 || (_state$labourDetails9 = state.labourDetails) === null || _state$labourDetails9 === void 0 ? void 0 : _state$labourDetails9.some(function (item) { return item.StatusName === StatusEnum.Completed; });
                    if (isSomeWorkCompleted) {
                        // updateDocumentStatus("Work In Progress", StatusEnum.WorkStarted);
                        return {
                            Key: StatusEnum.WorkStarted,
                            StatusName: "Work In Progress"
                        };
                    }
                    var isReadyForWork = state === null || state === void 0 || (_state$labourDetails10 = state.labourDetails) === null || _state$labourDetails10 === void 0 ? void 0 : _state$labourDetails10.every(function (item) { return item.StatusName === StatusEnum.Awaiting; });
                    if (isReadyForWork) {
                        // updateDocumentStatus("Open", StatusEnum.ReadyForWork);
                        return {
                            Key: StatusEnum.ReadyForWork,
                            StatusName: "Open"
                        };
                    }
                    var isWorkInProgress = state === null || state === void 0 || (_state$labourDetails11 = state.labourDetails) === null || _state$labourDetails11 === void 0 ? void 0 : _state$labourDetails11.some(function (item) { return item.StatusName === StatusEnum.Awaiting; });
                    if (isWorkInProgress) {
                        if ((SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === E_Channel_Name.CV) {
                            // updateDocumentStatus("Open", StatusEnum.ReadyForWork);
                            return {
                                Key: StatusEnum.ReadyForWork,
                                StatusName: "Open"
                            };
                        }
                        if ((SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) !== E_Channel_Name.CV) {
                            if (state !== null && state !== void 0 && state.TechnicianId) {
                                // updateDocumentStatus("Work In Progress", StatusEnum.WorkStarted);
                                return {
                                    Key: StatusEnum.WorkStarted,
                                    StatusName: "Work In Progress"
                                };
                            }
                            else {
                                // updateDocumentStatus("Open", StatusEnum.ReadyForWork);
                                return {
                                    Key: StatusEnum.ReadyForWork,
                                    StatusName: "Open"
                                };
                            }
                        }
                    }
                    break;
            }
        },
        getFormAPI: getAllJobCardDetailsAPICall,
        getKey: JobCardKeys.Get,
        getRequest: {
            JobCardId: id,
            TenantId: storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId
        },
        updateFormAPI: updateJobCardDetailsApicall,
        updateKey: JobCardKeys.Update,
        updateRequest: {
            accidentalDetailsPhotographList: accidentalDetailsPhotographList,
            accidentalDetailsAudioList: accidentalDetailsAudioList,
            OrganizationId: storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId,
            ParentOrganizationId: storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.ParentOrganizationId,
            suggestions: suggestions,
            futureAdviceList: futureAdviseList,
            InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy86 = documentDetailsGetById.data) === null || _documentDetailsGetBy86 === void 0 ? void 0 : _documentDetailsGetBy86.InstallBaseId
        },
        rbacRoute: parentModulePath,
        gridProps: {
            spacing: 0
        },
        updateFromSubmitResponse: true,
        state: {
            accidentalDetailsAttachments: __spreadArray(__spreadArray([], accidentalDetailsPhotographList, true), accidentalDetailsAudioList, true)
            // StatusName: documentDetailsGetById?.data?.StatusName,
            // Key: documentDetailsGetById?.data?.Key,
            // FinalInspectorId: documentDetailsGetById?.data?.FinalInspectorId,
            // SourceDocumentNo: documentDetailsGetById?.data?.SourceDocumentNo,
            // CDMSError: documentDetailsGetById?.data?.SourceMessage?.ErrorMessage ?? undefined,
        }
    }), /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: openStatusProgress,
        onClose: function () { return setOpenStatusProgress(function (prev) { return !prev; }); },
        sx: {
            "& .MuiDrawer-paper": {
                width: IS_MOBILE ? '60%' : IS_TABLET ? '40%' : "25%"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(VehicleInspectionStepper, {
        steps: progessSteps,
        onClickCloseIcon: function () {
            setOpenStatusProgress(false);
        }
    }))), /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: openServiceEstimate,
        onClose: function () { return onDrawerSEClick(); },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                width: IS_MOBILE ? '90%' : IS_TABLET ? '50%' : "40%"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(ServiceEstimateDrawer, {
        estimateId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy87 = documentDetailsGetById.data) === null || _documentDetailsGetBy87 === void 0 ? void 0 : _documentDetailsGetBy87.ParentId,
        Code: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy88 = documentDetailsGetById.data) === null || _documentDetailsGetBy88 === void 0 ? void 0 : _documentDetailsGetBy88.Code,
        parentModuleName: EParentModuleName.Jobcard,
        onCrossClick: onDrawerSEClick,
        onViewClick: onViewEstimateClick,
        onRevisedEstimateClick: onRevisedEstimateClick
    }))), (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy89 = documentDetailsGetById.data) === null || _documentDetailsGetBy89 === void 0 ? void 0 : _documentDetailsGetBy89.id) && /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: anchorElDelayedPopup,
        onClose: handleCloseDelayedPopup,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(DelayedPopup, {
        onClose: handleCloseDelayedPopup,
        jobcardNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy90 = documentDetailsGetById.data) === null || _documentDetailsGetBy90 === void 0 ? void 0 : _documentDetailsGetBy90.SourceDocumentNo,
        difference: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy91 = documentDetailsGetById.data) !== null && _documentDetailsGetBy91 !== void 0 && _documentDetailsGetBy91.EstimateDeliveryDateTime ? moment().diff(moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy92 = documentDetailsGetById.data) === null || _documentDetailsGetBy92 === void 0 ? void 0 : _documentDetailsGetBy92.EstimateDeliveryDateTime), 'minutes') : 0,
        estimatedDeliveryTime: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy93 = documentDetailsGetById.data) !== null && _documentDetailsGetBy93 !== void 0 && _documentDetailsGetBy93.EstimateDeliveryDateTime ? moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy94 = documentDetailsGetById.data) === null || _documentDetailsGetBy94 === void 0 ? void 0 : _documentDetailsGetBy94.EstimateDeliveryDateTime).format('DD MMM, YYYY - h:mm A') : "",
        documentDateTime: moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy95 = documentDetailsGetById.data) === null || _documentDetailsGetBy95 === void 0 ? void 0 : _documentDetailsGetBy95.CreatedOn).format('DD MMM, YYYY - h:mm A')
    })), isAssignFIModalOpen && /*#__PURE__*/ React.createElement(AssignFinalInspectorPopup, {
        isOpen: isAssignFIModalOpen,
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy96 = documentDetailsGetById.data) === null || _documentDetailsGetBy96 === void 0 ? void 0 : _documentDetailsGetBy96.JobCardNo,
        jobCardData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        assignValue: assignValue,
        onClose: function () {
            setIsAssignFIModalOpen(false);
            setAnchorEl(null);
        }
    }), /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: openTaskSummery,
        onClose: function () { return onDrawerClick(); },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                width: IS_MOBILE ? '90%' : IS_TABLET ? '50%' : "40%"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(TaskSummary, {
        onCrossClick: onDrawerClick,
        jobCardData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        id: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy97 = documentDetailsGetById.data) === null || _documentDetailsGetBy97 === void 0 ? void 0 : _documentDetailsGetBy97.JobCardId
    }))), /*#__PURE__*/ React.createElement(ImageCaptureAndFileupload, {
        open: openUpload,
        clearPopUpImages: clearPopUpImages,
        isImageEmpty: function (value) { return handleEmptyImage(value); },
        handleModelClose: function (value) { return handleCancleClick(value); },
        handleConfirm: function (data) {
            handleConfirmClick(data);
        },
        downloadedImages: accidentalDetailsPhotographList !== null && accidentalDetailsPhotographList !== void 0 ? accidentalDetailsPhotographList : [],
        maxImageUploadLimit: 10,
        ParentId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy98 = documentDetailsGetById.data) === null || _documentDetailsGetBy98 === void 0 ? void 0 : _documentDetailsGetBy98.id,
        systemName: 'JobCardAccidentalDetail',
        deleteUrl: deleteAllJobCardAttachmentsUrl
    }), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
        isOpen: viewAllImages,
        onClosed: function () { return setViewAllImages(false); },
        images: accidentalDetailsPhotographList
    }), /*#__PURE__*/ React.createElement(AudioCapturePopUpComponent, {
        open: audioCaptureClick,
        handleModelClick: function (value) { return setAudioCaptureClick(value); },
        handleConfirmClick: function (audio) { return onConfirmClick(audio); }
    }), isViewImageDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isViewImageDrawerOpen,
        onClose: function () {
            setImageURL('');
            setIsViewImageDrawerOpen(false);
        },
        image: imageURL
    }), isAssignModalOpen && /*#__PURE__*/ React.createElement(AppointmentAssignReassignPopup, {
        isOpen: isAssignModalOpen,
        onClosed: function () {
            setIsAssignModalOpen(false);
            setAnchorEl(null);
        },
        data: assignValue,
        appointmentData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        moduleName: EListCardView.JobCard
    }), isUnsavedDataModalOpen && /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: isUnsavedDataModalOpen,
        onClosePopup: function (value) { return setIsUnsavedDataModalOpen(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    }));
};
export default JobCardDetailsM3;
